
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("9feT0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("3voN7")).NotificationLogs);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $3voN7 = parcelRequire("3voN7");

});
parcelRegister("3voN7", function(module, exports) {

$parcel$export(module.exports, "NotificationLogs", () => $ef130062a8e57433$export$1139895a5af7252e);

var $5uXOq = parcelRequire("5uXOq");

var $jEoQl = parcelRequire("jEoQl");
const $ef130062a8e57433$export$1139895a5af7252e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jEoQl.NotificationLogsPage), null);

});
parcelRegister("jEoQl", function(module, exports) {

$parcel$export(module.exports, "NotificationLogsPage", () => $1b0c57a6ac72964e$export$f3b513321a19158f);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $dAfqg = parcelRequire("dAfqg");

var $8pMQX = parcelRequire("8pMQX");

var $kH3pk = parcelRequire("kH3pk");
const $1b0c57a6ac72964e$export$f3b513321a19158f = ()=>{
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    if (!projectContext) {
        (0, $jcw0u.default)({
            meta: {
                id: 'ProjectContextNULL',
                packageName: 'jiraSpaAppsServicedeskNotificationLogs',
                teamName: 'spartans'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return null;
    }
    const isProjectAdmin = Boolean(projectContext?.isProjectAdmin);
    if (!isProjectAdmin) {
        (0, $jcw0u.default)({
            meta: {
                id: 'UserIsNotProjectAdmin',
                packageName: 'jiraSpaAppsServicedeskNotificationLogs',
                teamName: 'spartans'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "spa-apps-servicedesk-notification-logs.ui.notification-logs-page.project-not-found"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8pMQX.ProjectNotFound), null));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kH3pk.NotificationLogsTabLayout), {
        projectContext: projectContext
    });
};

});
parcelRegister("8pMQX", function(module, exports) {

$parcel$export(module.exports, "ProjectNotFound", () => $951f6bd200bf8b89$export$849d319c342682a2);
$parcel$export(module.exports, "ServiceHubNotFound", () => $951f6bd200bf8b89$export$1fbf518ac538659c);
$parcel$export(module.exports, "GenericError", () => $951f6bd200bf8b89$export$7d465be8efa67280);

var $5uXOq = parcelRequire("5uXOq");

var $aatTc = parcelRequire("aatTc");

var $32M8E = parcelRequire("32M8E");

var $lAOer = parcelRequire("lAOer");

var $3s0xG = parcelRequire("3s0xG");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $7xBz2 = parcelRequire("7xBz2");

var $lVQn8 = parcelRequire("lVQn8");

var $id7K0 = parcelRequire("id7K0");

var $bTyOW = parcelRequire("bTyOW");

var $fC09Q = parcelRequire("fC09Q");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $hjSul = parcelRequire("hjSul");

var $4R6GH = parcelRequire("4R6GH");

var $4AdE6 = parcelRequire("4AdE6");
const $951f6bd200bf8b89$export$849d319c342682a2 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const projectsPath = '/jira/projects';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: formatMessage((0, $4AdE6.default).notFoundDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3s0xG.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $fC09Q.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $4AdE6.default).notFoundTitle),
        description: formatMessage((0, $4AdE6.default).notFoundDescription),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
            to: projectsPath
        }, formatMessage((0, $4AdE6.default).notFoundAction))
    }));
};
const $951f6bd200bf8b89$export$1fbf518ac538659c = ()=>{
    const projectsPath = '/jira/projects';
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: formatMessage((0, $4R6GH.fg)('jcs_project_type_m3') ? (0, $4AdE6.default).customerHubNotFoundDocumentTitleJsm : (0, $4AdE6.default).serviceHubNotFoundDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3s0xG.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $fC09Q.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $4R6GH.fg)('jcs_project_type_m3') ? (0, $4AdE6.default).customerHubNotFoundTitle : (0, $4AdE6.default).serviceHubNotFoundTitle),
        description: formatMessage((0, $4AdE6.default).serviceHubNotFoundDescription),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
            to: projectsPath
        }, formatMessage((0, $4R6GH.fg)('jcs_project_type_m3') ? (0, $4AdE6.default).customerHubNotFoundAction : (0, $4AdE6.default).serviceHubNotFoundAction))
    }));
};
const $951f6bd200bf8b89$export$7d465be8efa67280 = ()=>{
    const interactionId = (0, $5uXOq.useContext)((0, $32M8E.default)).current;
    const labelStack = (0, $5uXOq.useContext)((0, $aatTc.default))?.labelStack;
    const traceId = (0, $5uXOq.useMemo)(()=>{
        const traceContext = (0, $7xBz2.getActiveTrace)();
        return traceContext?.traceId;
    }, []);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    let description = formatMessage((0, $4AdE6.default).genericErrorDescription);
    if (traceId) {
        const error = new Error('An error occurred while loading this page');
        description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            xcss: $951f6bd200bf8b89$var$styles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lVQn8.ErrorHashAndTraceId), {
            error: error,
            traceId: traceId
        })));
        if ((0, $4R6GH.fg)('add_ufo_error_in_service_desk_genericerror')) {
            const name = 'serviceDeskGenericError';
            if (interactionId) {
                (0, $lAOer.addError)(interactionId, name, labelStack ?? null, error.name, error.message, error.stack);
                // NOTE: to account for awaiting BM3 TTI in UFO code, however we don't need to wait for BM3 TTI when there is an error
                // https://atlassian.slack.com/archives/C01AY8132S3/p1736380314352749?thread_ts=1736377740.484469&cid=C01AY8132S3
                const activeInteraction = (0, $lAOer.getActiveInteraction)();
                activeInteraction?.holdActive.forEach((_, holdId)=>{
                    (0, $lAOer.removeHoldByID)(activeInteraction.id, holdId);
                });
            } else (0, $lAOer.addErrorToAll)(name, labelStack ?? null, error.name, error.message, error.stack);
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: formatMessage((0, $4AdE6.default).genericDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3s0xG.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $bTyOW.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $4AdE6.default).genericErrorTitle),
        description: description
    }));
};
const $951f6bd200bf8b89$var$styles = (0, $2s57o.xcss)({
    marginTop: 'space.100'
});

});
parcelRegister("lVQn8", function(module, exports) {

$parcel$export(module.exports, "ErrorHashAndTraceId", () => $6bb63dde5e44a95e$export$61354a7dde2c2d3c);

var $5uXOq = parcelRequire("5uXOq");

var $5oFIy = parcelRequire("5oFIy");

var $kobfu = parcelRequire("kobfu");

var $hurrh = parcelRequire("hurrh");
const $6bb63dde5e44a95e$export$61354a7dde2c2d3c = ({ error: error, traceId: traceId })=>{
    const errorHash = (0, $kobfu.getErrorHash)(error);
    const source = `Hash ${errorHash}\nTrace ${traceId}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
        action: "rendered",
        actionSubject: "errorHashAndTraceId",
        attributes: {
            errorHash: errorHash,
            traceId: traceId
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        role: "note"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hurrh.CodeBlockWithCopyButton), {
        source: source,
        copyCodeActionSubjectId: "copyErrorHashAndTraceId"
    })));
};

});
parcelRegister("hurrh", function(module, exports) {

$parcel$export(module.exports, "CodeBlockWithCopyButton", () => $e48150d967598599$export$ced1fc74d907d387);

var $5uXOq = parcelRequire("5uXOq");

var $fzUGr = parcelRequire("fzUGr");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $irzxp = parcelRequire("irzxp");
const $e48150d967598599$export$ced1fc74d907d387 = ({ source: source, copyCodeActionSubjectId: copyCodeActionSubjectId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $e48150d967598599$var$wrapperStyles,
        role: "region"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $irzxp.ActionContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $irzxp.CopyAction), {
        source: source,
        actionSubjectId: copyCodeActionSubjectId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fzUGr.default), {
        text: source,
        showLineNumbers: false,
        shouldWrapLongLines: false
    })));
const $e48150d967598599$var$wrapperStyles = (0, $2s57o.xcss)({
    width: '100%',
    position: 'relative'
});

});
parcelRegister("fzUGr", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a96956312d74a20$export$2e2bcd8739ae039);
/* code-block.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $la5nd = parcelRequire("la5nd");

var $jhA2F = parcelRequire("jhA2F");

var $bEVVW = parcelRequire("bEVVW");

var $gCl68 = parcelRequire("gCl68");
const $0a96956312d74a20$var$getCodeBlockStyles = {
    root: "_2rkoglpi _1dqoglyw _1wyb1crf _k48pi7a9 _1e0c1txw _vwz4gktf _1reo1wug _o572qvpr _1eimjvyg _bfhktkvp _syaz1fxt _ect41odn _1ozdn7od _7xinn7od _t7aun7od _1v15u2gc _ilvcu2gc _m29uu2gc _17wyu2gc _pn28u2gc _gz9fu2gc _1hmyegat _vblregat _vbulegat _wozj1yev _1agb1yev _lkm81yev _tv41hkgb _1hmimyb0 _1ra01n1a _1d4j1y44 _1f8gstnw _1pzyb3bt _j1w0ww7y _13cdh2mm _15ba126e _zvy9f705 _qcxof705 _14y71a66 _j0l11wug _1weckb7n _1na21hna _1xx2grf3 _x7c815vq _lh0y15vq _1m3815vq _qk1e15vq _12l6ysn8 _uga3ysn8 _mx8b7mnp _1kr87mnp _xo19t94y _1bemt94y _nalpstnw _151dstnw _1exb1q9c _1hgu1q9c _1mgnt94y _nhket94y _h909m7j4 _scgayz1z _ipl81e17 _jeky1l04 _1gec1a66 _1gx21e5h _1ls0df4r _vm2c1rh5 _12ok1rh5 _1ls01ule _rude1ule _1q16glyw _1io6glyw _juomusic _lcwuusic _1552u2gc _12afu2gc _28ddu2gc _1i8zu2gc _12tu1a66 _zu0j1a66 _euyxusvi _cahfusvi _zhnuidpf _1amdidpf _mbgcpf9b _bu7zpf9b _131n1giz _gy101giz _1wfuwrk5 _16kzwrk5 _9kk3moej _cjus1w1g _9k2r1m30 _nhmw1m30 _yl021m30 _eiht5x2v _t9zb5x2v _mqok1w1g _3hsg1w1g _i7ngn7od _9wu1fb2s _1xcoh55r _1t361fxt _137bh55r _1k7d1fxt _97lipnps _12nh9lu1 _1g0517qg _i2ig10m5 _326z1fxt _113p131l _1n6tpnps _tgu817qg _1k47pnps _g0lx1fxt _ys4e131l _7gp8h55r _1yvq10m5 _1vww10m5 _1rju10m5 _1v0lh55r _wmyy17qg _748n17qg _1mfn17qg _1d7e17qg _p2vr17qg _19o610m5 _kxov17qg _1np517qg _m2f517qg _1b9tpnps _1tq6pnps _1rd2pnps _1pbkpnps _k3lipnps _13zt131l _2g12fb2s _k86b10m5 _b5iy131l _gti3131l _1f0gpnps _9d3e17qg _qdiapnps _72uvpnps",
    showLineNumbers: "_170714ej _1i3h1txw _1huoidpf _1a9lidpf _20bqidpf _1oggidpf _bympidpf _9nnjidpf",
    dontShowLineNumbers: "_1i3h1ule _1huou2gc _1a9lu2gc _20bqu2gc _1oggu2gc _bympu2gc _9nnju2gc",
    shouldWrapLongLines: "_13dgkb7n",
    dontWrapLongLines: "_13dgkb7n"
};
/**
 * __Code block__
 *
 * A code block highlights an entire block of code and keeps the formatting.
 *
 * - [Examples](https://atlassian.design/components/code/code-block/examples)
 * - [Code](https://atlassian.design/components/code/code-block/code)
 * - [Usage](https://atlassian.design/components/code/code-block/usage)
 */ const $0a96956312d74a20$var$CodeBlock = /*#__PURE__*/ (0, $5uXOq.memo)(function CodeBlock({ showLineNumbers: showLineNumbers = true, firstLineNumber: firstLineNumber = 1, language: providedLanguage = 'text', highlight: highlight = '', highlightedStartText: highlightedStartText = 'Highlight start', highlightedEndText: highlightedEndText = 'Highlight end', testId: testId, text: text, codeBidiWarnings: codeBidiWarnings = true, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, shouldWrapLongLines: shouldWrapLongLines = false }) {
    const numLines = (text || '').split('\n').length + (firstLineNumber > 0 ? firstLineNumber : 1) - 1;
    const lineNumberWidth = numLines ? (0, $jhA2F.getLineNumWidth)(numLines) : 0;
    const { getHighlightStyles: getHighlightStyles, highlightedLines: highlightedLines } = (0, $la5nd.useHighlightLines)({
        highlight: highlight,
        testId: testId
    });
    const getLineProps = (0, $5uXOq.useCallback)((line)=>getHighlightStyles(line, highlightedLines), [
        getHighlightStyles,
        highlightedLines
    ]);
    const language = (0, $5uXOq.useMemo)(()=>(0, $bEVVW.normalizeLanguage)(providedLanguage), [
        providedLanguage
    ]);
    // https://product-fabric.atlassian.net/browse/DST-2472
    const languageToUse = text ? language : 'text';
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gCl68.default), {
        "data-code-lang": language,
        "data-ds--code--code-block": "",
        testId: testId,
        language: languageToUse,
        style: {
            '--ads-code-line-number-width': `calc(${lineNumberWidth} + 16px)`,
            '--ads-highlighted-start-text': highlightedStartText,
            '--ads-highlighted-end-text': highlightedEndText
        },
        showLineNumbers: showLineNumbers,
        firstLineNumber: firstLineNumber,
        lineProps: getLineProps,
        // shouldCreateParentElementForLines is needed to pass down props to each line.
        // This is necessary for both line highlighting and testId's, as each of
        // these rely on a data attribute being passed down to lines.
        shouldCreateParentElementForLines: highlight.length > 0 || !!testId,
        shouldWrapLongLines: shouldWrapLongLines,
        codeBidiWarnings: codeBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
        text: text,
        className: (0, $bwpsq.default)([
            $0a96956312d74a20$var$getCodeBlockStyles.root,
            shouldWrapLongLines ? $0a96956312d74a20$var$getCodeBlockStyles.shouldWrapLongLines : $0a96956312d74a20$var$getCodeBlockStyles.dontWrapLongLines,
            showLineNumbers ? $0a96956312d74a20$var$getCodeBlockStyles.showLineNumbers : $0a96956312d74a20$var$getCodeBlockStyles.dontShowLineNumbers
        ])
    });
});
$0a96956312d74a20$var$CodeBlock.displayName = 'CodeBlock';
var $0a96956312d74a20$export$2e2bcd8739ae039 = $0a96956312d74a20$var$CodeBlock;

});
parcelRegister("la5nd", function(module, exports) {

$parcel$export(module.exports, "useHighlightLines", () => $d16fc758e2d4acef$export$84415a200bdf33ed);

var $5uXOq = parcelRequire("5uXOq");
const $d16fc758e2d4acef$var$DEFAULT_LINE_EL_ATTR_OBJ = {
    'data-ds--code--row': ''
};
const $d16fc758e2d4acef$var$getLineStyleObject = (lineNumber, testId)=>{
    return testId ? {
        'data-testid': `${testId}-line-${lineNumber}`,
        ...$d16fc758e2d4acef$var$DEFAULT_LINE_EL_ATTR_OBJ
    } : $d16fc758e2d4acef$var$DEFAULT_LINE_EL_ATTR_OBJ;
};
const $d16fc758e2d4acef$export$84415a200bdf33ed = ({ highlight: highlight = '', testId: testId })=>{
    const highlightedLines = (0, $5uXOq.useMemo)(()=>{
        if (!highlight) return [];
        return highlight.split(',').map((num)=>{
            if (num.indexOf('-') > 0) {
                // We found a line group, e.g. 1-3
                const [from, to] = num.split('-').map(Number)// Sort by lowest value first, highest value last.
                .sort((a, b)=>a - b);
                return Array(to + 1).fill(undefined).map((_, index)=>index).slice(from, to + 1);
            }
            return Number(num);
        }).reduce((acc, val)=>acc.concat(val), []) || [];
    }, [
        highlight
    ]);
    const getHighlightStyles = (0, $5uXOq.useCallback)((lineNumber, highlightedLines)=>{
        if (!highlight || highlightedLines.length === 0) return $d16fc758e2d4acef$var$getLineStyleObject(lineNumber, testId);
        if (highlightedLines.includes(lineNumber)) {
            const highlightedDataAttrObj = {
                'data-ds--code--row--highlight': ''
            };
            return {
                ...highlightedDataAttrObj,
                ...$d16fc758e2d4acef$var$getLineStyleObject(lineNumber, testId)
            };
        }
        return $d16fc758e2d4acef$var$getLineStyleObject(lineNumber, testId);
    }, [
        highlight,
        testId
    ]);
    return {
        getHighlightStyles: getHighlightStyles,
        highlightedLines: highlightedLines
    };
};

});

parcelRegister("jhA2F", function(module, exports) {

$parcel$export(module.exports, "getLineNumWidth", () => $612757b728dd1aa7$export$cb7aec0206b595d2);
const $612757b728dd1aa7$export$cb7aec0206b595d2 = (numLines)=>{
    return !numLines ? '1ch' : `${numLines.toFixed(0).length}ch`;
};
const $612757b728dd1aa7$export$d5fcf1b7ff23707b = ()=>{
    return {
        display: 'inline',
        padding: '2px 0.5ch',
        backgroundColor: `var(--ds--code--bg-color,${"var(--ds-background-neutral, #091E420F)"})`,
        borderRadius: "var(--ds-border-radius, 3px)",
        borderStyle: 'none',
        boxDecorationBreak: 'clone',
        color: "var(--ds-text, #172B4D)",
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        fontWeight: "var(--ds-font-weight-regular, 400)",
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    };
};

});

parcelRegister("bEVVW", function(module, exports) {

$parcel$export(module.exports, "normalizeLanguage", () => $4fed610104ef97c9$export$f38728011c178796);

var $8QpSo = parcelRequire("8QpSo");

var $fTglf = parcelRequire("fTglf");
const $4fed610104ef97c9$export$f38728011c178796 = (0, $8QpSo.default)((language)=>{
    if (!language) return '';
    const match = (0, $fTglf.SUPPORTED_LANGUAGES).find((val)=>{
        return val.name === language || val.alias.includes(language);
    });
    // Fallback to plain monospaced text if language passed but not supported
    return match ? match.value : 'text';
});

});
parcelRegister("fTglf", function(module, exports) {

$parcel$export(module.exports, "SUPPORTED_LANGUAGES", () => $c6e245aeba898e2e$export$7c77c3a9bb93870d);
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages

const $c6e245aeba898e2e$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    },
    {
        name: 'Handlebars',
        alias: [
            'handlebars',
            'mustache'
        ],
        value: 'handlebars'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'abap'
    }
];

});


parcelRegister("gCl68", function(module, exports) {

$parcel$export(module.exports, "default", () => $868e310e7b464206$export$2e2bcd8739ae039);
/**
 * Original library: https://github.com/react-syntax-highlighter/react-syntax-highlighter
 * All modifications by Atlassian
 */ /**
 * MIT License
 *
 * Copyright (c) 2019 Conor Hastings
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * __Syntax Highlighter__
 *
 * A syntax highlighter based on top of [refractor](https://github.com/wooorm/refractor).
 * @atlaskit/code uses this under-the-hood, but it is not intended for public consumption.
 * You should be using @atlaskit/code directly.
 */ 
var $6HXiV = parcelRequire("6HXiV");
var $868e310e7b464206$export$2e2bcd8739ae039 = (0, $6HXiV.default);

});
parcelRegister("6HXiV", function(module, exports) {

$parcel$export(module.exports, "default", () => $23f9107b8996345e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $25Oq3 = parcelRequire("25Oq3");
// Uses the loader method of async bundling
// Instantiates highligher as a singleton, loading refractor only once per page (refractor/prism are singleton modules)
const $23f9107b8996345e$var$generator = (options)=>{
    const { loader: loader } = options;
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class AsyncHighlighter extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
        static{
            this.astGenerator = null;
        }
        static{
            this.highlightInstance = (0, $25Oq3.default);
        }
        // Useful in tests
        static preload() {
            return AsyncHighlighter.loadAstGenerator();
        }
        static loadAstGenerator() {
            AsyncHighlighter.astGeneratorPromise = loader().then((astGenerator)=>{
                AsyncHighlighter.astGenerator = astGenerator;
                return astGenerator;
            });
            return AsyncHighlighter.astGeneratorPromise;
        }
        componentDidMount() {
            if (!AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.loadAstGenerator();
            if (!AsyncHighlighter.astGenerator && AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.astGeneratorPromise.then(()=>{
                this.forceUpdate();
            });
        }
        render() {
            return /*#__PURE__*/ (0, $2OMIu.jsx)(AsyncHighlighter.highlightInstance, {
                ...this.props,
                astGenerator: AsyncHighlighter.astGenerator
            });
        }
    }
    return AsyncHighlighter;
};

const $23f9107b8996345e$var$asyncGenerator = $23f9107b8996345e$var$generator({
    loader: ()=>(parcelRequire("7t3wc")).then((module)=>{
            // Webpack 3 returns module.exports as default as module, but webpack 4 returns module.exports as module.default
            return module.default || module;
        })
});
var $23f9107b8996345e$export$2e2bcd8739ae039 = $23f9107b8996345e$var$asyncGenerator;

});
parcelRegister("25Oq3", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a3f60eeac7eb983$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jPgP9 = parcelRequire("jPgP9");

var $39BkO = parcelRequire("39BkO");
/**
 * Takes in a code string and (in the default behaviour):
 * - Uses refractor to turn it into a tree structure with highlighting metadata
 * - Collapses this tree into lines for a renderer
 * - Passes these lines to a React renderer
 *
 * In future, the final step could have a custom renderer.
 */ const $3a3f60eeac7eb983$var$Highlight = /*#__PURE__*/ (0, $5uXOq.memo)(function Highlight({ language: language = 'text', testId: testId, text: text = '', codeTagProps: codeTagProps = {
    className: `language-${language}`
}, showLineNumbers: showLineNumbers = false, firstLineNumber: firstLineNumber = 1, shouldCreateParentElementForLines: shouldCreateParentElementForLines = false, shouldWrapLongLines: shouldWrapLongLines = false, lineProps: lineProps = {}, codeBidiWarnings: codeBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, astGenerator: astGenerator = null, ...rest }) {
    // TODO maybe we call this code or text everywhere; for now we match the API in
    // @atlaskit/codeblock
    const code = text;
    const generatorClassName = 'prismjs';
    const containerProps = {
        ...rest,
        'data-testid': testId,
        className: rest.className ? `${generatorClassName} ${rest.className}` : generatorClassName
    };
    if (shouldWrapLongLines) codeTagProps.style = {
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word'
    };
    else codeTagProps.style = {
        whiteSpace: 'pre'
    };
    const codeBidiWarningConfig = {
        codeBidiWarnings: codeBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
    };
    // Tree + logic into rows
    const rows = (0, $jPgP9.default)({
        astGenerator: astGenerator,
        code: code,
        language: language,
        shouldCreateParentElementForLines: shouldCreateParentElementForLines || !!shouldWrapLongLines,
        lineProps: lineProps,
        showLineNumbers: showLineNumbers,
        firstLineNumber: firstLineNumber
    });
    // Rows + logic into a renderer
    return (0, $39BkO.default)({
        containerProps: containerProps,
        codeTagProps: codeTagProps,
        rows: rows,
        codeBidiWarningConfig: codeBidiWarningConfig
    });
});
var $3a3f60eeac7eb983$export$2e2bcd8739ae039 = $3a3f60eeac7eb983$var$Highlight;

});
parcelRegister("jPgP9", function(module, exports) {

$parcel$export(module.exports, "default", () => $83f127a4a907a87e$export$2e2bcd8739ae039);

var $3MiM2 = parcelRequire("3MiM2");

var $1BFv0 = parcelRequire("1BFv0");

var $fQLWH = parcelRequire("fQLWH");

var $gmwnr = parcelRequire("gmwnr");
const $83f127a4a907a87e$var$newLineRegex = /\n/g;
function $83f127a4a907a87e$var$getNewLines(str) {
    return str.match($83f127a4a907a87e$var$newLineRegex);
}
function $83f127a4a907a87e$export$2e2bcd8739ae039({ astGenerator: astGenerator, code: code, language: language, shouldCreateParentElementForLines: shouldCreateParentElementForLines, lineProps: lineProps, showLineNumbers: showLineNumbers, firstLineNumber: firstLineNumber = 1 }) {
    const codeTree = (0, $gmwnr.default)(language, code, astGenerator);
    const startingLineNumber = firstLineNumber > 0 ? firstLineNumber : 1;
    const createLine = (0, $3MiM2.default)(lineProps, shouldCreateParentElementForLines, showLineNumbers);
    const newTree = [];
    let lastLineBreakIndex = -1;
    let index = 0;
    // Seems odd we flatten the tree immediately - what work could we do on it more performantly than on the lines?
    const tree = (0, $fQLWH.default)(codeTree);
    while(index < tree.length){
        const testNode = tree[index];
        if (testNode.type === 'text') {
            index++;
            continue;
        }
        const node = testNode;
        const firstChildNode = node.children[0];
        if (firstChildNode.type === 'text') {
            const { value: value } = firstChildNode;
            const newLines = $83f127a4a907a87e$var$getNewLines(value);
            if (newLines) {
                const splitValue = value.split('\n');
                splitValue.forEach((text, i)=>{
                    const lineNumber = newTree.length + startingLineNumber;
                    const newChild = {
                        type: 'text',
                        value: `${text}\n`
                    };
                    // if it's the first line
                    if (i === 0) {
                        const children = tree.slice(lastLineBreakIndex + 1, index).concat((0, $1BFv0.default)({
                            children: [
                                newChild
                            ],
                            className: node.properties.className,
                            lineNumber: lineNumber
                        }));
                        const line = createLine(children, lineNumber);
                        newTree.push(line);
                    // if it's the last line
                    } else if (i === splitValue.length - 1) {
                        const nextNode = tree[index + 1];
                        const stringChild = nextNode && nextNode.children && nextNode.children[0];
                        // Similar to newChild above, but no newline
                        const lastLineInPreviousSpan = {
                            type: 'text',
                            value: `${text}`
                        };
                        if (stringChild) {
                            const newElem = (0, $1BFv0.default)({
                                children: [
                                    lastLineInPreviousSpan
                                ],
                                className: node.properties.className,
                                lineNumber: lineNumber
                            });
                            tree.splice(index + 1, 0, newElem);
                        } else {
                            const children = [
                                lastLineInPreviousSpan
                            ];
                            const line = createLine(children, lineNumber, node.properties.className);
                            newTree.push(line);
                        }
                    // if it's neither the first nor the last line
                    } else {
                        const children = [
                            newChild
                        ];
                        const line = createLine(children, lineNumber, node.properties.className);
                        newTree.push(line);
                    }
                });
                lastLineBreakIndex = index;
            }
        }
        index++;
    }
    if (lastLineBreakIndex !== tree.length - 1) {
        const children = tree.slice(lastLineBreakIndex + 1, tree.length);
        if (children && children.length) {
            const lineNumber = newTree.length + startingLineNumber;
            const line = createLine(children, lineNumber);
            newTree.push(line);
        }
    }
    if (shouldCreateParentElementForLines) return newTree;
    // If shouldCreateParentElementForLines was off, we still have a tree structure we need to flatten
    // We have (RefractorNode | RefractorNode[])[] but need RefractorNode[]
    // This seems like a code smell to review
    return newTree.flat(1);
}

});
parcelRegister("3MiM2", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c5ea60b42d5d4bb$export$2e2bcd8739ae039);

var $1BFv0 = parcelRequire("1BFv0");

var $54p18 = parcelRequire("54p18");
function $5c5ea60b42d5d4bb$var$createLineGenerator(lineProps, shouldCreateParentElementForLines, showLineNumbers) {
    return (children, lineNumber, className = [])=>{
        // Needed for more complex line creation
        if (shouldCreateParentElementForLines || className.length > 0) return (0, $1BFv0.default)({
            children: children,
            lineNumber: lineNumber,
            showLineNumbers: showLineNumbers,
            lineProps: lineProps,
            className: className
        });
        else {
            // Simple line creation without the bells and whistles
            if (showLineNumbers && lineNumber) children.unshift((0, $54p18.default)(lineNumber));
            return children;
        }
    };
}
var $5c5ea60b42d5d4bb$export$2e2bcd8739ae039 = $5c5ea60b42d5d4bb$var$createLineGenerator;

});
parcelRegister("1BFv0", function(module, exports) {

$parcel$export(module.exports, "default", () => $172b8b54beacc18d$export$2e2bcd8739ae039);

var $54p18 = parcelRequire("54p18");
function $172b8b54beacc18d$export$2e2bcd8739ae039({ children: children, lineNumber: lineNumber, showLineNumbers: showLineNumbers, lineProps: lineProps = {}, className: className = [] }) {
    const propsPassedInFromCodeBlock = typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps;
    const properties = {
        ...propsPassedInFromCodeBlock,
        className: className
    };
    let currentChildren = children;
    if (lineNumber && showLineNumbers) {
        // When syntax highlighting is NOT turned on, the entire LOC is just a single
        // child. We can then happily create the line number and the LOC as siblings...
        if (currentChildren.length === 1) currentChildren = [
            (0, $54p18.default)(lineNumber),
            ...currentChildren
        ];
        else // ... However, when syntax highlighting IS on, a span is created for each
        // tokenised node in the AST (eg. <span>import</span><span>React</span>).
        // When shouldWrapLongLines is true, the row becomes `display: flex` and
        // forces all its children to be equal height. This can be a source of
        // visual bugs where a LOC is broken up weirdly into segments.
        //
        //  +---------------------------------------+
        //  | row                                   |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  |  |line| |key    | |keywords| |key   | |
        //  |  |no. | |word   | |        | |word  | |
        //  |  |    | |       | |        | |      | |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  +---------------------------------------+
        //
        // Nesting the children one layer deeper (i.e. creating an extra span)
        // ensures that the line number and the ENTIRE line of code are aligned by
        // the parent flexbox (the row).
        //
        //  +---------------------------------------------+
        //  | row                                         |
        //  | +----+  +--------------------------------+  |
        //  | |line|  | extra span we are creating     |  |
        //  | |no. |  |  +-------+ +--------+ +------+ |  |
        //  | |    |  |  |key    | |keywords| |key   | |  |
        //  | |    |  |  |word   | |        | |word  | |  |
        //  | |    |  |  |       | |        | |      | |  |
        //  | |    |  |  +-------+ +--------+ +------+ |  |
        //  | +----+  +--------------------------------+  |
        //  +---------------------------------------------+
        //
        currentChildren = [
            (0, $54p18.default)(lineNumber),
            {
                type: 'element',
                tagName: 'span',
                properties: {
                    className: []
                },
                children: currentChildren
            }
        ];
    }
    return {
        type: 'element',
        tagName: 'span',
        properties: properties,
        children: currentChildren
    };
}

});
parcelRegister("54p18", function(module, exports) {

$parcel$export(module.exports, "default", () => $3834caf662eda994$export$2e2bcd8739ae039);
function $3834caf662eda994$export$2e2bcd8739ae039(lineNumber) {
    return {
        type: 'element',
        tagName: 'span',
        properties: {
            key: `line-number--${lineNumber}`,
            className: [
                'comment',
                'linenumber',
                'ds-line-number'
            ],
            // We're placing the lineNumber in a data-attr on an empty span (hence the
            // empty children array below). This allows CodeBlock to use CSS to
            // generate the content in a pseudo-element, which is a fix for a bug
            // where line numbers were being copied (CSS content can't be copied)
            // https://product-fabric.atlassian.net/browse/DSP-2729
            'data-ds--line-number': lineNumber
        },
        children: []
    };
}

});



parcelRegister("fQLWH", function(module, exports) {

$parcel$export(module.exports, "default", () => $59c252c59a03fc27$export$2e2bcd8739ae039);

var $1BFv0 = parcelRequire("1BFv0");
function $59c252c59a03fc27$export$2e2bcd8739ae039(tree, offset = 0, className = []) {
    let newTree = [];
    for(let i = 0; i < tree.length; i++){
        const node = tree[i];
        if (node.type === 'text') newTree.push((0, $1BFv0.default)({
            children: [
                node
            ],
            lineNumber: offset,
            className: className
        }));
        else if (node.children) {
            const classNames = className.concat(node.properties.className || []);
            $59c252c59a03fc27$export$2e2bcd8739ae039(node.children, offset + 1, classNames).forEach((i)=>newTree.push(i));
        }
    }
    return newTree;
}

});

parcelRegister("gmwnr", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0e0821c048da7b0$export$2e2bcd8739ae039);
function $e0e0821c048da7b0$export$2e2bcd8739ae039(language, code, astGenerator) {
    if (language === 'text' || !astGenerator) return [
        {
            type: 'text',
            value: code
        }
    ];
    try {
        return astGenerator.highlight(code, language);
    } catch (e) {
        return [
            {
                type: 'text',
                value: code
            }
        ];
    }
}

});


parcelRegister("39BkO", function(module, exports) {

$parcel$export(module.exports, "default", () => $b50830aca1ec5f8b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dMYCB = parcelRequire("dMYCB");
function $b50830aca1ec5f8b$export$2e2bcd8739ae039({ containerProps: containerProps, codeTagProps: codeTagProps, rows: rows, codeBidiWarningConfig: codeBidiWarningConfig }) {
    const renderedRows = rows.map((node, i)=>(0, $dMYCB.default)({
            node: node,
            codeBidiWarningConfig: codeBidiWarningConfig,
            key: `code-segment${i}`
        }));
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...containerProps,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("code", {
            ...codeTagProps,
            children: renderedRows
        })
    });
}

});
parcelRegister("dMYCB", function(module, exports) {

$parcel$export(module.exports, "default", () => $dde6b95e25c7a358$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $UXrz9 = parcelRequire("UXrz9");

var $lmODa = parcelRequire("lmODa");

var $gBK9d = parcelRequire("gBK9d");
function $dde6b95e25c7a358$var$createClassNameString(classNames) {
    return classNames ? classNames.join(' ') : '';
}
function $dde6b95e25c7a358$export$2e2bcd8739ae039({ node: node, codeBidiWarningConfig: codeBidiWarningConfig, key: key }) {
    if (node.type === 'text') {
        const { value: value } = node;
        // occasionally a numeric value is passed when the type is text
        const textValue = `${value}`;
        if (codeBidiWarningConfig.codeBidiWarnings) {
            const decorated = (0, $lmODa.default)(textValue, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $UXrz9.default), {
                    bidiCharacter: bidiCharacter,
                    label: codeBidiWarningConfig.codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningConfig.codeBidiWarningTooltipEnabled
                }, index));
            return decorated;
        }
        return textValue;
    } else {
        const { properties: properties, tagName: tagName } = node;
        const childrenCreator = (0, $gBK9d.default)(codeBidiWarningConfig);
        const props = {
            ...properties,
            className: $dde6b95e25c7a358$var$createClassNameString(properties.className)
        };
        const children = childrenCreator(node.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(tagName, {
            key: key,
            ...props
        }, children);
    }
}

});
parcelRegister("UXrz9", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6fb86ced30fc4f0$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5KCCi = parcelRequire("5KCCi");

var $eMkc6 = parcelRequire("eMkc6");
function $f6fb86ced30fc4f0$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, tooltipEnabled: tooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    if (tooltipEnabled) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
        content: label,
        tag: $f6fb86ced30fc4f0$var$CustomizedTagWithRef,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eMkc6.Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter,
            children: skipChildren ? null : bidiCharacter
        })
    }));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eMkc6.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter,
        children: skipChildren ? null : bidiCharacter
    });
}
const $f6fb86ced30fc4f0$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...rest,
        ref: ref,
        children: children
    });
});

});
parcelRegister("eMkc6", function(module, exports) {

$parcel$export(module.exports, "Decorator", () => $6a3ad388ce84f83d$export$a592b67c93d52467);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cBCgC = parcelRequire("cBCgC");
const $6a3ad388ce84f83d$var$decoration = {
    root: "_kqswh2mm _szpl2smr _dsq41wug _1xyt1b66 _123w1b66 _15nnze3t _rxygze3t _1a354jg8 _1j6r1odn _1uakf6fq _1kt9y7el _is06wx40 _1rus1tzq _1cfcvrvc _24gj1h6o _19o61h6o _cfu1116y _1rbawx40 _1xqc1rd4"
};
function $6a3ad388ce84f83d$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $6a3ad388ce84f83d$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                "data-testid": testId,
                "data-bidi-character-code": bidiCharacterCode,
                // This is set to true so that the content is not read out by
                // screen readers as the content includes angle brackets for
                // visual decoration purposes.
                // We use a visually hidden `mark` element below for screen readers
                "aria-hidden": "true",
                className: (0, $bwpsq.default)([
                    $6a3ad388ce84f83d$var$decoration.root
                ]),
                children: children
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cBCgC.default), {
                testId: testId && `${testId}--visually-hidden`,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("mark", {
                    children: bidiCharacterCode
                })
            })
        ]
    });
}
function $6a3ad388ce84f83d$var$getBidiCharacterCode(bidiCharacter) {
    const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
    return `U+${bidiCharacterCode}`;
}

});


parcelRegister("lmODa", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dfe4bd40045326b$export$2e2bcd8739ae039);
const $8dfe4bd40045326b$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
function $8dfe4bd40045326b$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll($8dfe4bd40045326b$export$ecb256e6a1f5ee7e)
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});

parcelRegister("gBK9d", function(module, exports) {

$parcel$export(module.exports, "default", () => $b17e0d9de8ef9bb6$export$2e2bcd8739ae039);

var $dMYCB = parcelRequire("dMYCB");
function $b17e0d9de8ef9bb6$export$2e2bcd8739ae039(codeBidiWarningConfig) {
    let childrenCount = 0;
    return (children)=>{
        childrenCount += 1;
        return children.map((child, i)=>(0, $dMYCB.default)({
                node: child,
                codeBidiWarningConfig: codeBidiWarningConfig,
                key: `code-segment-${childrenCount}-${i}`
            }));
    };
}

});




parcelRegister("7t3wc", function(module, exports) {

let $56fdf880767119f7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $56fdf880767119f7$var$load("as9qs").then(()=>parcelRequire('5zvIl'));

});




parcelRegister("irzxp", function(module, exports) {

$parcel$export(module.exports, "CopyAction", () => $64e12044af483692$export$958df07cbf9735fc);
$parcel$export(module.exports, "ActionContainer", () => $64e12044af483692$export$37ab3bdebc286ca);

var $5uXOq = parcelRequire("5uXOq");

var $jHTSg = parcelRequire("jHTSg");

var $86vzA = parcelRequire("86vzA");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $8zOmE = parcelRequire("8zOmE");

var $fEogx = parcelRequire("fEogx");
const $64e12044af483692$export$2ce9877c9c1aa16 = {
    PROMPT: 'Copy',
    SUCCESS: 'Copied!',
    FAILURE: 'Copy to clipboard failed'
};
const $64e12044af483692$export$958df07cbf9735fc = ({ source: source, actionSubjectId: actionSubjectId })=>{
    const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)($64e12044af483692$export$2ce9877c9c1aa16.PROMPT);
    const handleSuccess = (0, $5uXOq.useCallback)(()=>{
        setTooltipMessage($64e12044af483692$export$2ce9877c9c1aa16.SUCCESS);
    }, [
        setTooltipMessage
    ]);
    const handleError = (0, $5uXOq.useCallback)(()=>{
        setTooltipMessage($64e12044af483692$export$2ce9877c9c1aa16.FAILURE);
    }, [
        setTooltipMessage
    ]);
    const writeToClipboard = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        actionSubjectId && (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'clicked button', actionSubjectId);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        navigator.clipboard.writeText(source).then(handleSuccess, handleError);
    }, [
        source,
        handleSuccess,
        handleError,
        actionSubjectId
    ]);
    const resetMessage = (0, $5uXOq.useCallback)(()=>{
        setTooltipMessage($64e12044af483692$export$2ce9877c9c1aa16.PROMPT);
    }, [
        setTooltipMessage
    ]);
    function shouldRender() {
        if (typeof document !== 'undefined') // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return Boolean(navigator?.clipboard?.writeText);
    }
    return shouldRender() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fEogx.Action), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($86vzA))),
        label: tooltipMessage,
        onClick: writeToClipboard,
        onMouseOver: resetMessage,
        onFocus: resetMessage,
        "aria-live": "assertive",
        "aria-atomic": "true",
        name: "Copy"
    }) : null;
};
const $64e12044af483692$var$stopPropagation = (event)=>event.stopPropagation();
const $64e12044af483692$export$37ab3bdebc286ca = ({ children: children })=>/**
	 * This element uses an `onMouseDown` to block event propagation
	 * to its parent but is not itself interactive.
	 */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $64e12044af483692$var$absolutePositionWrapperStyles,
        onMouseDown: $64e12044af483692$var$stopPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jHTSg.default), {
        label: "actions"
    }, children));
const $64e12044af483692$var$absolutePositionWrapperStyles = (0, $2s57o.xcss)({
    position: 'absolute',
    top: 'space.0',
    right: 'space.0',
    padding: 'space.050',
    zIndex: 'flag'
});

});
parcelRegister("fEogx", function(module, exports) {

$parcel$export(module.exports, "Action", () => $e6da05ade6347218$export$e19cd5f9376f8cee);

var $5uXOq = parcelRequire("5uXOq");

var $1Seuh = parcelRequire("1Seuh");

var $5KCCi = parcelRequire("5KCCi");
const $e6da05ade6347218$export$e19cd5f9376f8cee = ({ icon: icon, label: label, tooltipLabel: tooltipLabel, isLoading: isLoading, ...buttonProps })=>{
    const updateTooltip = (0, $5uXOq.useRef)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        tooltipLabel,
        label
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
        content: ({ update: update })=>{
            updateTooltip.current = update;
            return tooltipLabel || label;
        },
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Seuh.default), {
        isLoading: isLoading,
        appearance: "subtle",
        icon: icon,
        label: label,
        spacing: "compact",
        ...buttonProps
    }));
};

});




parcelRegister("id7K0", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $938046587fdeeb52$export$dd5ad0b65cf665da);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $4CAXd = parcelRequire("4CAXd");
// eslint-disable-next-line jira/react/no-class-components
class $938046587fdeeb52$var$DocumentTitleOld extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $4CAXd.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber = (0, $4CAXd.DocumentTitleSubscriber) } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CAXd.DocumentTitleHelperOld), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}
const $938046587fdeeb52$export$dd5ad0b65cf665da = (0, $cSD7y.componentWithFG)('jira-concurrent-document-title', (0, $4CAXd.DocumentTitleHelper), $938046587fdeeb52$var$DocumentTitleOld);

});

parcelRegister("bTyOW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5073396748f92b4e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "viewBox", () => $5073396748f92b4e$export$a179c88182cb9d56);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("5I4tL")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("h8kvT")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = m5v37k2r2scm86wgmrk6
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/m5v37k2r2scm86wgmrk6

var $dCLgq = parcelRequire("dCLgq");

var $h8kvT = parcelRequire("h8kvT");

var $5I4tL = parcelRequire("5I4tL");
const $5073396748f92b4e$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($5I4tL)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($h8kvT))
});
var $5073396748f92b4e$export$2e2bcd8739ae039 = $5073396748f92b4e$var$Illustration;
// for advanced use only
const $5073396748f92b4e$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    218
];

});
parcelRegister("h8kvT", function(module, exports) {
module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();

});

parcelRegister("5I4tL", function(module, exports) {
module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();

});


parcelRegister("fC09Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb376757c4acc5ab$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("3pGSh")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("3pGSh")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 53grvvhrxck68z6q4s7ztq4p
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/53grvvhrxck68z6q4s7ztq4p

var $dCLgq = parcelRequire("dCLgq");

var $3pGSh = parcelRequire("3pGSh");
const $bb376757c4acc5ab$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($3pGSh)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($3pGSh))
});
var $bb376757c4acc5ab$export$2e2bcd8739ae039 = $bb376757c4acc5ab$var$Illustration;
// for advanced use only
const $bb376757c4acc5ab$export$a179c88182cb9d56 = [
    0,
    0,
    167,
    226
];

});
parcelRegister("3pGSh", function(module, exports) {
module.exports = new URL("search-error.a6df7c97.svg", import.meta.url).toString();

});


parcelRegister("4AdE6", function(module, exports) {

$parcel$export(module.exports, "default", () => $135a9e70a6f11b3e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $135a9e70a6f11b3e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    notFoundDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-document-title-jsm",
        "defaultMessage": "Project not found - Service project"
    },
    notFoundTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-title",
        "defaultMessage": "This project isn't available"
    },
    notFoundDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-description",
        "defaultMessage": "It may have been deleted or your permissions may have changed"
    },
    notFoundAction: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-action",
        "defaultMessage": "View a list of all projects"
    },
    genericDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-document-title-jsm",
        "defaultMessage": "Error - Service project"
    },
    genericErrorTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-title",
        "defaultMessage": "An error occurred"
    },
    genericErrorDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-description",
        "defaultMessage": "An error occurred while loading this page"
    },
    serviceHubNotFoundDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.servicehub-not-found-document-title-jsm",
        "defaultMessage": "Service hub not found - Service project"
    },
    serviceHubNotFoundTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.servicehub-not-found-title",
        "defaultMessage": "This service hub isn't available"
    },
    serviceHubNotFoundDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.servicehub-not-found-description",
        "defaultMessage": "It may have been deleted or your permissions may have changed"
    },
    serviceHubNotFoundAction: {
        "id": "servicedesk-spa-commons.common.utils.errors.servicehub-not-found-action",
        "defaultMessage": "View a list of all service hubs"
    },
    customerHubNotFoundDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.customer-hub-not-found-document-title-jsm",
        "defaultMessage": "Customer hub not found - Service project"
    },
    customerHubNotFoundTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.customer-hub-not-found-title",
        "defaultMessage": "This customer hub isn't available"
    },
    customerHubNotFoundAction: {
        "id": "servicedesk-spa-commons.common.utils.errors.customer-hub-not-found-action",
        "defaultMessage": "View a list of all customer hubs"
    }
});

});


parcelRegister("kH3pk", function(module, exports) {

$parcel$export(module.exports, "NotificationLogsTabLayout", () => $035b2a23228d11ed$export$8c09fdd1a5e9a6e3);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $gpo4s = parcelRequire("gpo4s");
var $8LGam = parcelRequire("8LGam");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $cS37j = parcelRequire("cS37j");

var $7CMCs = parcelRequire("7CMCs");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $4R6GH = parcelRequire("4R6GH");

var $bfjnH = parcelRequire("bfjnH");

var $h6N5n = parcelRequire("h6N5n");

var $jrqHH = parcelRequire("jrqHH");

var $jNffj = parcelRequire("jNffj");

var $1Cifx = parcelRequire("1Cifx");
const $035b2a23228d11ed$var$GetNotificationLogsBreadcrumbs = (projectContext, breadcrumbRoot)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8LGam.default), {
        onExpand: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gpo4s.default), {
        text: breadcrumbRoot,
        href: "/jira/projects"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gpo4s.default), {
        text: `${projectContext?.projectName}`,
        href: `/browse/${projectContext?.projectKey}`
    }));
const $035b2a23228d11ed$export$8c09fdd1a5e9a6e3 = ({ projectContext: projectContext })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const breadcrumbRoot = formatMessage((0, $jrqHH.messages).projects);
    const breadcrumbs = $035b2a23228d11ed$var$GetNotificationLogsBreadcrumbs(projectContext, breadcrumbRoot);
    const outgoingMailConfigData = (0, $bfjnH.useOutgoingMailConfig)();
    const { outgoingMailConfig: outgoingMailConfig, error: error, loading: loading } = outgoingMailConfigData;
    if (error) (0, $jcw0u.default)({
        meta: {
            id: 'ErrorFetchingOutgoingMailConfigDataInTabsLayout',
            packageName: 'jiraSpaAppsServicedeskNotificationLogs',
            teamName: 'spartans'
        },
        error: new Error(error),
        sendToPrivacyUnsafeSplunk: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "CustomerNotificationLogsInTabsLayout",
        packageName: "jiraSpaAppsServicedeskNotificationLogs",
        teamName: "spartans"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "customerNotificationLogs",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $035b2a23228d11ed$var$notificationAppStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), {
        breadcrumbs: breadcrumbs
    }, formatMessage((0, $jrqHH.messages).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !(0, $4R6GH.fg)('unsuppress_customer_emails') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jNffj.NotificationAppSubHeader), null), outgoingMailConfig !== null && !error && !loading && !outgoingMailConfig?.enabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireTrackAnalytics), {
        eventName: "LogsTableInTabsLayout OutGoingMailDisabledText"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h6N5n.EnableOutgoingMailInfo), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Cifx.NotificationTabs), {
        projectContext: projectContext,
        outgoingMailConfigData: outgoingMailConfigData
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null)));
};
const $035b2a23228d11ed$var$notificationAppStyles = (0, $2s57o.xcss)({
    marginLeft: 'space.500',
    marginRight: 'space.500'
});

});
// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("bfjnH", function(module, exports) {

$parcel$export(module.exports, "useOutgoingMailConfig", () => $1eb57df3368ecafc$export$a0d5dcab564be259);

var $5uXOq = parcelRequire("5uXOq");
const $1eb57df3368ecafc$export$a0d5dcab564be259 = ()=>{
    const [outgoingMailConfig, setOutgoingMailConfig] = (0, $5uXOq.useState)(null);
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)(null);
    (0, $5uXOq.useEffect)(()=>{
        const fetchOutgoingMailConfig = async ()=>{
            try {
                setLoading(true);
                const response = await fetch('/rest/jira-mail-plugin/1.0/outgoingMail/config');
                if (!response.ok) throw new Error('Failed to fetch outgoingMailConfig');
                const data = await response.json();
                setOutgoingMailConfig(data);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                setError(e.message);
            } finally{
                setLoading(false);
            }
        };
        fetchOutgoingMailConfig();
    }, []);
    return {
        outgoingMailConfig: outgoingMailConfig,
        loading: loading,
        error: error
    };
};

});

parcelRegister("h6N5n", function(module, exports) {

$parcel$export(module.exports, "EnableOutgoingMailInfo", () => $50f0893185fbc96c$export$c75e44dac0fdc638);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $5E93O = parcelRequire("5E93O");

var $8Q4sF = parcelRequire("8Q4sF");

var $koVbs = parcelRequire("koVbs");

var $dcwaU = parcelRequire("dcwaU");
const $50f0893185fbc96c$var$Bold = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, children);
const $50f0893185fbc96c$export$c75e44dac0fdc638 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const siteUrl = window.location.hostname;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($50f0893185fbc96c$var$OutgoingMailErrorText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5E93O))), {
        LEGACY_size: "medium",
        spacing: "spacious",
        label: "",
        color: "var(--ds-icon-danger, #C9372C)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Q4sF.FormattedI18nMessage), {
        message: formatMessage((0, $dcwaU.messages).configDisabledAndHasFailureLogs, {
            boldStart: '{boldStart}',
            boldEnd: '{boldEnd}',
            siteUrl: siteUrl
        }),
        componentsMapping: {
            bold: $50f0893185fbc96c$var$Bold
        }
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $50f0893185fbc96c$var$OutgoingMailErrorText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qutpp _u5f3utpp _n3tdutpp _19bvidpf _1e0c1o8l _154iidpf _kqsw1if8 _1pbyowjs _bfhkvuon _1bsb1osq _vr2wh2mm _1t1812x7 _1tnd12x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8Q4sF", function(module, exports) {

$parcel$export(module.exports, "FormattedI18nMessage", () => $7c8c20575fbc9bfc$export$200d7bd7633253ce);

var $5uXOq = parcelRequire("5uXOq");

var $gHDlh = parcelRequire("gHDlh");

var $9Byym = parcelRequire("9Byym");
const $7c8c20575fbc9bfc$export$200d7bd7633253ce = (props)=>{
    const { message: message, packageName: packageName, componentsMapping: componentsMapping } = props;
    const messageParts = (0, $5uXOq.useMemo)(()=>{
        const { tags: tags, openTags: openTags, closeTags: closeTags } = (0, $9Byym.getTags)(componentsMapping);
        try {
            const parts = [];
            let token = '';
            let TagComponent;
            let closeTagLookup;
            for(let i = 0; i < message.length; i += 1){
                const letter = message[i];
                token += letter;
                if ((0, $9Byym.isCloseTagDelimiter)(letter)) {
                    const firstTagFound = (0, $9Byym.findTag)(token, {
                        tags: openTags
                    });
                    if (firstTagFound !== null && firstTagFound !== undefined) {
                        // if we have a tag already means it is a malformed message since it is 2 subsequent open tags
                        if (TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                        const text = token.replace(firstTagFound, '');
                        parts.push(text);
                        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
                        const tagInfo = tags[firstTagFound];
                        TagComponent = tagInfo.component;
                        closeTagLookup = tagInfo.close;
                        token = '';
                    }
                }
                if (closeTagLookup !== null && closeTagLookup !== undefined && (0, $9Byym.isCloseTagDelimiter)(letter) && (0, $9Byym.isAnyTag)(token, {
                    tags: [
                        closeTagLookup
                    ]
                })) {
                    // this mean that we do not have an open tag for this closing tag
                    if (!TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                    const text = token.replace(closeTagLookup, '');
                    parts.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TagComponent, null, text));
                    TagComponent = undefined;
                    token = '';
                    closeTagLookup = undefined;
                }
                if ((0, $9Byym.isCloseTagDelimiter)(letter) && (0, $9Byym.isAnyTag)(token, {
                    tags: closeTags
                })) {
                    // if we do not have an open tag mean we are closing a tag that is not open
                    if (!TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                }
            }
            // if we reached the end and we have an open tag, mean this message is malformed
            if (TagComponent || closeTagLookup) throw new (0, $gHDlh.MalformedMessageError)();
            // flush anything we keep in the current token
            if (token.length > 0) parts.push(token);
            return parts;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e instanceof (0, $gHDlh.MalformedMessageError)) {
                (0, $gHDlh.logMalformedMessageError)({
                    message: message,
                    packageName: packageName
                });
                return [
                    (0, $gHDlh.getMalformedMessage)({
                        message: message,
                        closeTags: closeTags,
                        openTags: openTags
                    })
                ];
            }
            throw e;
        }
    }, [
        message,
        packageName,
        componentsMapping
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, messageParts.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
            key: index
        }, item)));
};

});
parcelRegister("gHDlh", function(module, exports) {

$parcel$export(module.exports, "getMalformedMessage", () => $ecff24857c176a60$export$f085cf20ec1f69ab);
$parcel$export(module.exports, "logMalformedMessageError", () => $ecff24857c176a60$export$954c3e6aad1c9429);
$parcel$export(module.exports, "MalformedMessageError", () => $ecff24857c176a60$export$40d900e818b9630e);

var $dJl1T = parcelRequire("dJl1T");

var $jcw0u = parcelRequire("jcw0u");

const $ecff24857c176a60$export$f085cf20ec1f69ab = ({ message: message, openTags: openTags, closeTags: closeTags })=>[
        ...openTags,
        ...closeTags
    ].reduce((acc, tag)=>acc.replace(new RegExp(tag, 'g'), ''), message);
const $ecff24857c176a60$export$954c3e6aad1c9429 = ({ message: message, packageName: packageName })=>{
    if (packageName !== null && packageName !== undefined) {
        const errorMessage = `Malformed message: ${message}`;
        // Send error log to analytics pipeline (i.e. SFX) and Sentry
        (0, $jcw0u.default)({
            meta: {
                packageName: packageName,
                id: (0, $5514815b06163219$export$f3390a0e172fee41)
            },
            attributes: {
                message: errorMessage
            }
        });
        // Send error log to Splunk
        const location = `${packageName}.${(0, $5514815b06163219$export$f3390a0e172fee41)}`;
        (0, $dJl1T.default).unsafeErrorWithCustomerData(location, errorMessage);
    }
};
class $ecff24857c176a60$export$40d900e818b9630e extends Error {
    constructor(){
        super('Malformed i18n message');
    }
}

});
const $5514815b06163219$export$f3390a0e172fee41 = 'formattedI18NMessage';


parcelRegister("9Byym", function(module, exports) {

$parcel$export(module.exports, "getTags", () => $84498158f946a67b$export$af63d7414243dad3);
$parcel$export(module.exports, "isAnyTag", () => $84498158f946a67b$export$38ffa64fc639355f);
$parcel$export(module.exports, "findTag", () => $84498158f946a67b$export$dfca0f74034f8657);
$parcel$export(module.exports, "isCloseTagDelimiter", () => $84498158f946a67b$export$d5170904651e91b1);

const $84498158f946a67b$export$af63d7414243dad3 = (componentsMapping)=>Object.entries(componentsMapping).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (acc, [key, value])=>{
        const open = `{${key}Start}`;
        const close = `{${key}End}`;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        acc.tags[open] = {
            close: close,
            component: value
        };
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.openTags.push(open);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.closeTags.push(close);
        return acc;
    }, {
        tags: {},
        openTags: [],
        closeTags: []
    });
const $84498158f946a67b$export$38ffa64fc639355f = (text, { tags: tags })=>tags.some((tag)=>text.includes(tag));
const $84498158f946a67b$export$dfca0f74034f8657 = (text, { tags: tags })=>tags.find((tag)=>text.includes(tag));
const $84498158f946a67b$export$d5170904651e91b1 = (letter)=>letter === (0, $7ed9c0b663db8b35$export$a10c567c3288a6b4);

});
const $7ed9c0b663db8b35$export$a10c567c3288a6b4 = '}';



parcelRegister("dcwaU", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a40a3a906225b436$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $a40a3a906225b436$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    configDisabledAndHasFailureLogs: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.enable-outgoing-mail-info.config-disabled-and-has-failure-logs",
        "defaultMessage": "We couldn\u2019t refresh data because your Jira admin has disabled {boldStart}Outgoing Mail{boldEnd} for {siteUrl}."
    }
});

});


parcelRegister("jrqHH", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d6fefbde36dd395e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $d6fefbde36dd395e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.title",
        "defaultMessage": "Customer notification logs"
    },
    projects: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.projects",
        "defaultMessage": "Projects"
    }
});

});

parcelRegister("jNffj", function(module, exports) {

$parcel$export(module.exports, "NotificationAppSubHeader", () => $6620b65b00a8c86d$export$8f6ed0d18980040c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $jZrSh = parcelRequire("jZrSh");

var $ck7yD = parcelRequire("ck7yD");
const $6620b65b00a8c86d$export$8f6ed0d18980040c = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const articleId = '3VlB3YNCvdJ8c8zzo50d85';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const onLearnMoreLinkClicked = (0, $5uXOq.useCallback)(()=>(0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'learnMoreAboutCustomerNotificationLogsLink',
            action: 'clicked'
        }), 'learnMoreAboutCustomerNotificationLogs'), [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6620b65b00a8c86d$var$SubHeaderContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": "spa-apps-servicedesk-notification-logs.ui.notification-logs-page.notification-logs-tab-layout.notification-app-sub-header.span"
    }, formatMessage((0, $ck7yD.messages).knowMoreInfoText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZrSh.InProductHelpLink), {
        href: "",
        inProductHelpArticleId: articleId,
        learnMoreText: formatMessage((0, $ck7yD.messages).learnMoreText),
        onClick: onLearnMoreLinkClicked
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6620b65b00a8c86d$var$SubHeaderContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyrpxbi _1kdcu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jZrSh", function(module, exports) {

$parcel$export(module.exports, "InProductHelpLink", () => $32955e92f3319f63$export$4fe0f115bd124cae);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8zIDr = parcelRequire("8zIDr");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $8oe80 = parcelRequire("8oe80");

var $4R6GH = parcelRequire("4R6GH");

var $5Zxxp = parcelRequire("5Zxxp");
const $32955e92f3319f63$export$4fe0f115bd124cae = ({ href: href, inProductHelpArticleId: inProductHelpArticleId, learnMoreText: learnMoreText, onClick: onClick = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) })=>{
    const learnMoreLink = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($32955e92f3319f63$var$LinkWithAnalytics, {
        target: "_blank",
        rel: "noopener noreferrer",
        href: href,
        onClick: onClick
    }, learnMoreText);
    if (inProductHelpArticleId === undefined && !(0, $4R6GH.fg)('help_panel_as_link')) return learnMoreLink;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($32955e92f3319f63$var$LinkStyledHelpPanelButton, {
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "servicedesk-common.components.in-product-help-link.link-styled-help-panel-button",
        fallbackComponent: learnMoreLink,
        articleId: inProductHelpArticleId,
        onClick: onClick,
        appearance: "link",
        spacing: "none",
        href: href
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $32955e92f3319f63$var$linkTextContainerstyles
    }, learnMoreText));
};
const $32955e92f3319f63$var$linkTextContainerstyles = (0, $2s57o.xcss)({
    whiteSpace: 'normal'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $32955e92f3319f63$var$LinkStyledHelpPanelButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $5Zxxp.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4bfu18uv _1hms8stv _ajmmnqa1 _1r5p1kw7",
            __cmplp.className
        ])
    });
});
const $32955e92f3319f63$var$LinkWithAnalytics = (0, $8oe80.default)('link', {
    onClick: 'clicked'
})((0, $8zIDr.default));

});

parcelRegister("ck7yD", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7327e8745c0e5367$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $7327e8745c0e5367$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    knowMoreInfoText: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-app-sub-header.know-more-info-text",
        "defaultMessage": "View undelivered email notifications for the last 21 days. "
    },
    learnMoreText: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-app-sub-header.learn-more-text",
        "defaultMessage": "Read more about customer notification logs. "
    }
});

});


parcelRegister("1Cifx", function(module, exports) {

$parcel$export(module.exports, "NotificationTabs", () => $4639157a6fdfd4fc$export$5dd40b7e2c20a9df);

var $jJzIg = parcelRequire("jJzIg");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $j3wJV = parcelRequire("j3wJV");
var $7WSFu = parcelRequire("7WSFu");
var $gRhg6 = parcelRequire("gRhg6");
var $epUnZ = parcelRequire("epUnZ");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $koeKL = parcelRequire("koeKL");

var $4R6GH = parcelRequire("4R6GH");

var $jNffj = parcelRequire("jNffj");

var $3OoGN = parcelRequire("3OoGN");

var $4W8YQ = parcelRequire("4W8YQ");
const $4639157a6fdfd4fc$export$2ddb90ad54e5f587 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4639157a6fdfd4fc$var$PanelWrapper, {
        "data-testid": testId
    }, children);
const $4639157a6fdfd4fc$export$2b91517d6d5b4365 = (0, $jJzIg.default);
const $4639157a6fdfd4fc$export$5dd40b7e2c20a9df = ({ projectContext: projectContext, outgoingMailConfigData: outgoingMailConfigData })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const tabTitles = [
        'customerInvite',
        'issueFailure'
    ];
    const [selectedTab, setSelectedTab] = (0, $5uXOq.useState)('CUSTOMER_INVITE');
    const cloudId = (0, $koeKL.useCloudId)();
    const projectId = projectContext?.projectId;
    const projectKey = projectContext?.projectKey;
    // // Create a unique fetchKey for each selectedTab
    const fetchKey = (0, $5uXOq.useMemo)(()=>selectedTab, [
        selectedTab
    ]);
    // Use useLazyLoadQuery to fetch data
    const emailData = (0, $8Uumt.useLazyLoadQuery)($4639157a6fdfd4fc$export$2b91517d6d5b4365, {
        cloudId: cloudId,
        projectId: projectId,
        notificationType: selectedTab === 'CUSTOMER_INVITE' ? null : 'CUSTOMER_NOTIFICATION.ISSUE',
        notificationActionType: selectedTab === 'CUSTOMER_INVITE' ? 'CUSTOMER_INVITE' : null,
        isUnsuppressionEnabled: (0, $4R6GH.fg)('unsuppress_customer_emails')
    }, {
        fetchKey: fetchKey,
        fetchPolicy: 'network-only'
    });
    // Handle tab change
    const handleTabChange = (index)=>{
        if (index === 0) {
            const analyticsEventForCustomerInvite = createAnalyticsEvent({
                actionSubject: 'customerInviteNotificationTabs',
                action: 'clicked'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEventForCustomerInvite);
            setSelectedTab('CUSTOMER_INVITE');
        }
        if (index === 1) {
            const analyticsEventForIssueNotification = createAnalyticsEvent({
                actionSubject: 'issueNotificationNotificationTabs',
                action: 'clicked'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEventForIssueNotification);
            setSelectedTab('ISSUE_NOTIFICATION');
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j3wJV.default), {
        onChange: handleTabChange,
        id: "default"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gRhg6.default), null, tabTitles.map((title, index)=>{
        if (title === 'customerInvite') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7WSFu.default), {
            key: index,
            testId: "spa-apps-servicedesk-notification-logs.ui.notification-logs-page.notification-logs-tab-layout.notification-tabs.tab-1"
        }, formatMessage((0, $3OoGN.messages).customerInvite), ' ');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7WSFu.default), {
            key: index,
            testId: "spa-apps-servicedesk-notification-logs.ui.notification-logs-page.notification-logs-tab-layout.notification-tabs.tab-2"
        }, formatMessage((0, $3OoGN.messages).issueFailure));
    })), tabTitles.map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $epUnZ.default), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4639157a6fdfd4fc$export$2ddb90ad54e5f587, {
            testId: `spa-apps-servicedesk-notification-logs.ui.notification-logs-page.notification-logs-tab-layout.notification-tabs.panel-${index + 1}`
        }, (0, $4R6GH.fg)('unsuppress_customer_emails') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            xcss: $4639157a6fdfd4fc$var$subHeaderStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jNffj.NotificationAppSubHeader), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4W8YQ.NotificationLogsTable), {
            emailData: emailData,
            projectKey: projectKey,
            outgoingMailConfigData: outgoingMailConfigData,
            selectedTab: selectedTab
        })))));
};
const $4639157a6fdfd4fc$var$subHeaderStyles = (0, $2s57o.xcss)({
    marginTop: 'space.200'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4639157a6fdfd4fc$var$PanelWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jJzIg", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4efbb2d9b0f0d09$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<edfeb3cf059095a5b67ac1594bdb9030>>
 * @relayHash 4f65c6189d896574bf6ec36dbe116f12
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 71241e9e7fc404acd1b23615af90c1197ceefddf71cff1f0587a3d7940e3ecb1
const $b4efbb2d9b0f0d09$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isUnsuppressionEnabled"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "notificationActionType"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "notificationType"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "notificationTabsQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "notificationTable_spaAppsServicedeskNotificationLogs_NotificationLogsTable"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "notificationTabsQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "AquaOutgoingEmailLogsQueryApi",
                    "kind": "LinkedField",
                    "name": "aquaOutgoingEmailLogs",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "notificationActionType",
                                    "variableName": "notificationActionType"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "notificationType",
                                    "variableName": "notificationType"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "projectId",
                                    "variableName": "projectId"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "GetNotificationLogs",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v6 /*: any*/ ,
                                            "concreteType": "AquaOutgoingEmailLogConnection",
                                            "kind": "LinkedField",
                                            "name": "logs",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "AquaOutgoingEmailLogItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AquaOutgoingEmailLogItem",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "AquaIssueContext",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueContext",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssue",
                                                                            "kind": "LinkedField",
                                                                            "name": "issue",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "key"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "webUrl"
                                                                                },
                                                                                v7 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "notificationActionType"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "actionTimestamp"
                                                                },
                                                                {
                                                                    "concreteType": "AquaNotificationDetails",
                                                                    "kind": "LinkedField",
                                                                    "name": "notificationDetails",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "errorKey"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "mailboxMessage"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "recipient",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        {
                                                                            "condition": "isUnsuppressionEnabled",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "accountId"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "email"
                                                                                }
                                                                            ],
                                                                            "type": "AtlassianAccountUser"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "name"
                                                                                }
                                                                            ],
                                                                            "type": "CustomerUser"
                                                                        },
                                                                        v7 /*: any*/ 
                                                                    ]
                                                                },
                                                                v5 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "startCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasPreviousPage"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "logs(first:20)"
                                        },
                                        {
                                            "args": v6 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "aquaOutgoingEmail__logs",
                                            "kind": "LinkedHandle",
                                            "name": "logs"
                                        }
                                    ],
                                    "type": "AquaOutgoingEmailLog"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "identifier"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v7 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "71241e9e7fc404acd1b23615af90c1197ceefddf71cff1f0587a3d7940e3ecb1",
            "metadata": {},
            "name": "notificationTabsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b4efbb2d9b0f0d09$var$node.hash = "e4deb4a803ece0490b86ed0f2df93fed";
var $b4efbb2d9b0f0d09$export$2e2bcd8739ae039 = $b4efbb2d9b0f0d09$var$node;

});

parcelRegister("j3wJV", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a852196e4486364$export$2e2bcd8739ae039);
/* tabs.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eNCZ4 = parcelRequire("eNCZ4");

var $6GQ51 = parcelRequire("6GQ51");
const $6a852196e4486364$var$baseStyles = null;
const $6a852196e4486364$var$tabsStyles = null;
const $6a852196e4486364$var$analyticsAttributes = {
    componentName: 'tabs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $6a852196e4486364$var$getTabPanelWithContext = ({ tabPanel: tabPanel, index: index, isSelected: isSelected, tabsId: tabsId })=>// Ensure tabPanel exists in case it has been removed
    tabPanel && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6GQ51.TabPanelContext).Provider, {
        value: {
            role: 'tabpanel',
            id: `${tabsId}-${index}-tab`,
            hidden: isSelected ? undefined : true,
            'aria-labelledby': `${tabsId}-${index}`,
            tabIndex: isSelected ? 0 : -1
        },
        children: tabPanel
    }, index); /**
                                * __Tabs__
                                *
                                * Tabs acts as a container for all Tab components.
                                *
                                * - [Examples](https://atlassian.design/components/tabs/examples)
                                * - [Code](https://atlassian.design/components/tabs/code)
                                * - [Usage](https://atlassian.design/components/tabs/usage)
                                */ 
const $6a852196e4486364$var$Tabs = (props)=>{
    const { shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange = false, selected: SelectedType, defaultSelected: defaultSelected, onChange: onChangeProp, id: id, analyticsContext: analyticsContext, children: children, testId: testId } = props;
    const [selectedState, setSelected] = (0, $5uXOq.useState)(SelectedType || defaultSelected || 0);
    const selected = SelectedType === undefined ? selectedState : SelectedType;
    const childrenArray = (0, $5uXOq.Children).toArray(children) // Don't include any conditional children
    .filter((child)=>Boolean(child)); // First child should be a tabList followed by tab panels
    const [tabList, ...tabPanels] = childrenArray; // Keep track of visited and add to a set
    const visited = (0, $5uXOq.useRef)(new Set([
        selected
    ]));
    if (!visited.current.has(selected)) visited.current.add(selected);
    const onChange = (0, $5uXOq.useCallback)((index, analyticsEvent)=>{
        if (onChangeProp) onChangeProp(index, analyticsEvent);
        setSelected(index);
    }, [
        onChangeProp
    ]);
    const onChangeAnalytics = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$6a852196e4486364$var$analyticsAttributes
    });
    const tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $6a852196e4486364$var$getTabPanelWithContext({
        tabPanel: tabPanels[selected],
        index: selected,
        isSelected: true,
        tabsId: id
    }) : // If a panel has already been visited, don't unmount it
    Array.from(visited.current).map((tabIndex)=>$6a852196e4486364$var$getTabPanelWithContext({
            tabPanel: tabPanels[tabIndex],
            index: tabIndex,
            isSelected: tabIndex === selected,
            tabsId: id
        }));
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _p12f1osq _1tkeidpf _i0dl1osq _2lx21bp4 _16jlkb7n",
            "_1c3y1txw _ftfaidpf _18i0kb7n _185bglyw"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6GQ51.TabListContext).Provider, {
                value: {
                    selected: selected,
                    onChange: onChangeAnalytics,
                    tabsId: id
                },
                children: tabList
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
                children: tabPanelsWithContext
            })
        ]
    });
};
var $6a852196e4486364$export$2e2bcd8739ae039 = $6a852196e4486364$var$Tabs;

});
parcelRegister("6GQ51", function(module, exports) {

$parcel$export(module.exports, "TabContext", () => $c165e92c256273eb$export$5a5d356ca5f10a0a);
$parcel$export(module.exports, "TabListContext", () => $c165e92c256273eb$export$aa6907f9fd69e93b);
$parcel$export(module.exports, "TabPanelContext", () => $c165e92c256273eb$export$2054129d247c3102);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $5uXOq = parcelRequire("5uXOq");
const $c165e92c256273eb$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $c165e92c256273eb$export$aa6907f9fd69e93b = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $c165e92c256273eb$export$2054129d247c3102 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);

});


parcelRegister("7WSFu", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccf4c2909ef7a2dd$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6fV04 = parcelRequire("6fV04");

var $k9nuy = parcelRequire("k9nuy");

var $7OlLO = parcelRequire("7OlLO");
/**
 * __Tab__
 *
 * Tab represents an indivudal Tab displayed in a TabList.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $ccf4c2909ef7a2dd$var$Tab = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function Tab({ children: children, testId: testId }, ref) {
    const { onClick: onClick, id: id, 'aria-controls': ariaControls, 'aria-posinset': ariaPosinset, 'aria-selected': ariaSelected, 'aria-setsize': ariaSetsize, onKeyDown: onKeyDown, role: role, tabIndex: tabIndex } = (0, $7OlLO.useTab)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6fV04.default), {
        isInset: true,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-testid": testId,
            onClick: onClick,
            id: id,
            "aria-controls": ariaControls,
            "aria-posinset": ariaPosinset,
            "aria-selected": ariaSelected,
            "aria-setsize": ariaSetsize,
            onKeyDown: onKeyDown,
            role: role,
            tabIndex: tabIndex,
            ref: ref,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                weight: "medium",
                color: "inherit",
                maxLines: 1,
                children: children
            })
        })
    });
});
var $ccf4c2909ef7a2dd$export$2e2bcd8739ae039 = $ccf4c2909ef7a2dd$var$Tab;

});
parcelRegister("7OlLO", function(module, exports) {

$parcel$export(module.exports, "useTab", () => $00738c41c5a8efbb$export$fdf4756d5b8ef90a);
$parcel$export(module.exports, "useTabList", () => $00738c41c5a8efbb$export$773e389e644c5874);
$parcel$export(module.exports, "useTabPanel", () => $00738c41c5a8efbb$export$fae0121b5afe572d);

var $5uXOq = parcelRequire("5uXOq");

var $6GQ51 = parcelRequire("6GQ51");
const $00738c41c5a8efbb$export$fdf4756d5b8ef90a = ()=>{
    const tabData = (0, $5uXOq.useContext)((0, $6GQ51.TabContext));
    if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
    return tabData;
};
const $00738c41c5a8efbb$export$773e389e644c5874 = ()=>{
    const tabListData = (0, $5uXOq.useContext)((0, $6GQ51.TabListContext));
    if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
    return tabListData;
};
const $00738c41c5a8efbb$export$fae0121b5afe572d = ()=>{
    const tabPanelData = (0, $5uXOq.useContext)((0, $6GQ51.TabPanelContext));
    if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
    return tabPanelData;
};

});


parcelRegister("gRhg6", function(module, exports) {

$parcel$export(module.exports, "default", () => $533db9168e866f5c$export$2e2bcd8739ae039);
/* tab-list.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fHpHg = parcelRequire("fHpHg");

var $7OlLO = parcelRequire("7OlLO");

var $6GQ51 = parcelRequire("6GQ51");
const $533db9168e866f5c$var$baseStyles = null;
const $533db9168e866f5c$var$tabListStyles = null;
const $533db9168e866f5c$var$tabListStylesOld = null;
/**
 * __TabList__
 *
 * A TabList groups `Tab` components together.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $533db9168e866f5c$var$TabList = ({ children: children })=>{
    const { tabsId: tabsId, selected: selected, onChange: onChange } = (0, $7OlLO.useTabList)();
    const ref = /*#__PURE__*/ (0, $5uXOq.createRef)();
    // Don't include any conditional children
    const childrenArray = (0, $5uXOq.Children).toArray(children).filter(Boolean);
    const length = childrenArray.length;
    const selectTabByIndex = (0, $5uXOq.useCallback)((index)=>{
        const newSelectedNode = ref.current?.querySelector(`[id='${tabsId}-${index}']`);
        if (newSelectedNode) newSelectedNode.focus();
        onChange(index);
    }, [
        tabsId,
        ref,
        onChange
    ]);
    const onKeyDown = (0, $5uXOq.useCallback)((e)=>{
        if (![
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(e.key)) return;
        // preventing horizontal or vertical scroll
        e.preventDefault();
        const lastTabIndex = length - 1;
        if ([
            'Home',
            'End'
        ].includes(e.key)) {
            const newSelected = e.key === 'Home' ? 0 : lastTabIndex;
            selectTabByIndex(newSelected);
            return;
        }
        // We use aria-posinset so we don't rely on the selected variable
        // If we used the selected variable this would regenerate each time
        // and create an unstable reference
        const selectedIndex = parseInt(e.currentTarget.getAttribute('aria-posinset') || '0') - 1;
        const modifier = e.key === 'ArrowRight' ? 1 : -1;
        let newSelected = selectedIndex + modifier;
        if (newSelected < 0 || newSelected >= length) // Cycling focus to move from last to first and from first to last
        newSelected = newSelected < 0 ? lastTabIndex : 0;
        selectTabByIndex(newSelected);
    }, [
        length,
        selectTabByIndex
    ]);
    // Memoized so the function isn't recreated each time
    const getTabWithContext = (0, $5uXOq.useCallback)(({ tab: tab, isSelected: isSelected, index: index })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $6GQ51.TabContext).Provider, {
            value: {
                onClick: ()=>onChange(index),
                onKeyDown: onKeyDown,
                'aria-setsize': length,
                role: 'tab',
                id: `${tabsId}-${index}`,
                'aria-posinset': index + 1,
                'aria-selected': isSelected,
                'aria-controls': `${tabsId}-${index}-tab`,
                tabIndex: isSelected ? 0 : -1
            },
            children: tab
        }, index), [
        length,
        onKeyDown,
        onChange,
        tabsId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "tablist",
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswh2mm _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            (0, $fHpHg.fg)('platform-component-visual-refresh') ? "_k48p1wq8 _ahbqx0bf _gpbcidpf _10vzidpf _1mmwidpf _15plidpf _7hip15vq _1fud15vq _bb0mh2mm _1quzjjyb _rzxytlke _1ofh12x7 _pryi12x7 _1a85u2gc _rmpau2gc _1dze1l2s _1tms1q9c _fiizidpf _1xrmidpf _xyihidpf _166qidpf _1lzu8zxi _24g71kw7 _140sidpf _lycustnw _15d8b3bt _1fztidpf _wd7eu2gc _1olcu2gc _1oazdud1 _w9ewidpf _170tidpf _y1g1idpf _1nvfidpf _1b8d8zxi _1n121kw7 _7p9oidpf _o2e1stnw _16u6b3bt _1yk1idpf _1lbou2gc _1c9uu2gc _1i201ouy _bppridpf _1mbxidpf _kn0bidpf _wsgdidpf _rsmz174y _1m0e1kw7 _93pdidpf _1sglstnw _1ksob3bt _1p9sidpf _1qa1u2gc _1jjcu2gc _fiem1ldt _pascidpf _eid3idpf _zr3eidpf _fntnidpf _1mp41kw7 _kfgte4h9 _1cs8stnw _1rushloo _1kt9b3bt _1fkridpf _1enwidpf _z5wtu2gc" : "_k48p1wq8 _ahbqx0bf _gpbcidpf _10vzidpf _1mmwidpf _15plidpf _7hip15vq _1fud15vq _bb0mh2mm _1quzjjyb _rzxytlke _1ofh12x7 _pryi12x7 _1a85u2gc _rmpau2gc _1dze1l2s _1tms1q9c _fiizidpf _1xrmidpf _xyihidpf _166qidpf _17hygqwt _1lzu1eqa _24g71kw7 _140sidpf _lycustnw _15d8b3bt _1fztidpf _wd7eu2gc _1olcu2gc _1oazdud1 _w9ewidpf _170tidpf _y1g1idpf _1nvfidpf _1jakgqwt _1b8d1eqa _1n121kw7 _7p9oidpf _o2e1stnw _16u6b3bt _1yk1idpf _1lbou2gc _1c9uu2gc _1i201ouy _bppridpf _1mbxidpf _kn0bidpf _wsgdidpf _9r9ugqwt _rsmz1gcm _1m0e1kw7 _93pdidpf _1sglstnw _1ksob3bt _1p9sidpf _1qa1u2gc _1jjcu2gc _fiem1ldt _pascidpf _eid3idpf _zr3eidpf _fntnidpf _rfx3gqwt _1mp41kw7 _kfgt1bk5 _1cs8stnw _1rushloo _1kt9b3bt _1fkridpf _1enwidpf _z5wtu2gc"
        ]),
        children: childrenArray.map((child, index)=>getTabWithContext({
                tab: child,
                index: index,
                isSelected: index === selected
            }))
    });
};
var $533db9168e866f5c$export$2e2bcd8739ae039 = $533db9168e866f5c$var$TabList;

});

parcelRegister("epUnZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5338e85086431969$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6fV04 = parcelRequire("6fV04");

var $7OlLO = parcelRequire("7OlLO");
// Note this is not being memoized as children is an unstable reference
/**
 * __TabPanel__
 *
 * A TabPanel houses the contents of a Tab.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $5338e85086431969$var$TabPanel = ({ children: children, testId: testId })=>{
    const { role: role, id: id, hidden: hidden, 'aria-labelledby': ariaLabelledBy, tabIndex: tabIndex } = (0, $7OlLO.useTabPanel)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6fV04.default), {
        isInset: true,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-testid": testId,
            role: role,
            id: id,
            hidden: hidden,
            "aria-labelledby": ariaLabelledBy,
            tabIndex: tabIndex,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
                children: children
            })
        })
    });
};
var $5338e85086431969$export$2e2bcd8739ae039 = $5338e85086431969$var$TabPanel;

});

parcelRegister("3OoGN", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b7743d2175162a1a$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $b7743d2175162a1a$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    customerInvite: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.customer-invite",
        "defaultMessage": "Customer invitations"
    },
    issueFailure: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.issue-failure",
        "defaultMessage": "Request notifications"
    }
});

});

parcelRegister("4W8YQ", function(module, exports) {

$parcel$export(module.exports, "NotificationLogsTable", () => $6b7c2ece765359d1$export$12ff1d4ce191bd1e);

var $ajbwj = parcelRequire("ajbwj");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9suPc = parcelRequire("9suPc");

var $8Uumt = parcelRequire("8Uumt");

var $jcw0u = parcelRequire("jcw0u");

var $5oFIy = parcelRequire("5oFIy");

var $ib5lJ = parcelRequire("ib5lJ");
const $6b7c2ece765359d1$var$PAZE_SIZE = 30;
const $6b7c2ece765359d1$var$NO_ERROR = 'No Error';
const $6b7c2ece765359d1$export$12ff1d4ce191bd1e = ({ emailData: emailData, projectKey: projectKey, outgoingMailConfigData: outgoingMailConfigData, selectedTab: selectedTab })=>{
    const { data: data, loadNext: loadNext } = (0, $8Uumt.usePaginationFragment)((0, $ajbwj.default), emailData);
    if (!data || !data.aquaOutgoingEmailLogs) {
        const validationError = new Error('Validation Error');
        (0, $jcw0u.default)({
            meta: {
                id: 'LogsQueryReturnedValidationErrorInTabsLayout',
                packageName: 'jiraSpaAppsServicedeskNotificationLogs',
                teamName: 'spartans'
            },
            error: validationError,
            sendToPrivacyUnsafeSplunk: true
        });
        throw validationError;
    }
    const responseType = data.aquaOutgoingEmailLogs?.GetNotificationLogs?.__typename;
    if (responseType === 'QueryError') {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const errorMessage = data.aquaOutgoingEmailLogs?.GetNotificationLogs?.message;
        const queryError = new Error(errorMessage);
        (0, $jcw0u.default)({
            meta: {
                id: 'LogsQueryReturnedErrorInTabsLayout',
                packageName: 'jiraSpaAppsServicedeskNotificationLogs',
                teamName: 'spartans'
            },
            error: queryError,
            sendToPrivacyUnsafeSplunk: true
        });
        throw queryError;
    }
    const hasMoreData = data.aquaOutgoingEmailLogs?.GetNotificationLogs?.logs?.pageInfo.hasNextPage;
    const allRows = data;
    const allRowEdges = allRows.aquaOutgoingEmailLogs?.GetNotificationLogs?.logs?.edges;
    const hasError = allRows.aquaOutgoingEmailLogs?.GetNotificationLogs?.identifier ? allRows.aquaOutgoingEmailLogs?.GetNotificationLogs.message : $6b7c2ece765359d1$var$NO_ERROR;
    const parentRef = (0, $5uXOq.useRef)(null);
    const getRowHeight = (0, $5uXOq.useCallback)(()=>60, []);
    const allRowsLength = allRowEdges ? allRowEdges.length : 0;
    const virtualizer = (0, $9suPc.useVirtualizer)({
        count: hasMoreData ? allRowsLength + 1 : allRowsLength,
        getScrollElement: ()=>parentRef.current,
        estimateSize: getRowHeight,
        overscan: 5
    });
    (0, $5uXOq.useEffect)(()=>{
        // save calling `getVirtualItems()` unnecessarily
        if (!allRowEdges || !hasMoreData) return;
        const lastItem = virtualizer.getVirtualItems().at(-1);
        if (lastItem && lastItem.index >= allRowEdges.length - 1) loadNext($6b7c2ece765359d1$var$PAZE_SIZE);
         // Do not change the dependency to just be `virtualizer` or `virtualizer.getVirtualItems`
    // it must call the function for dependencies to be calculated correctly (and therefore render at all).
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        allRowEdges,
        hasMoreData,
        loadNext,
        virtualizer.getVirtualItems()
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6b7c2ece765359d1$var$LogsTableWrapper, {
        tabIndex: 0,
        ref: parentRef
    }, hasError === $6b7c2ece765359d1$var$NO_ERROR && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireTrackAnalytics), {
        eventName: "LogsTableInTabsLayout Render"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ib5lJ.LogsTable), {
        virtualizer: virtualizer,
        allEdges: allRowEdges || [],
        projectKey: projectKey,
        outgoingMailConfigData: outgoingMailConfigData,
        selectedTab: selectedTab
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6b7c2ece765359d1$var$LogsTableWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo1wug _18m91wug _4t3in9zg _1bsb1osq _19pkpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ajbwj", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa75551a827aac92$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fd03fddac3701ccf11f77e86792181f4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $FXmIr = parcelRequire("FXmIr");
const $fa75551a827aac92$var$node = function() {
    var v0 = [
        "aquaOutgoingEmailLogs",
        "GetNotificationLogs",
        "logs"
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": 20,
                "kind": "LocalArgument",
                "name": "count"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cursor"
            },
            {
                "kind": "RootArgument",
                "name": "isUnsuppressionEnabled"
            },
            {
                "kind": "RootArgument",
                "name": "notificationActionType"
            },
            {
                "kind": "RootArgument",
                "name": "notificationType"
            },
            {
                "kind": "RootArgument",
                "name": "projectId"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "count",
                    "cursor": "cursor",
                    "direction": "forward",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "count",
                        "cursor": "cursor"
                    },
                    "backward": null,
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [],
                "operation": (0, $FXmIr.default)
            }
        },
        "name": "notificationTable_spaAppsServicedeskNotificationLogs_NotificationLogsTable",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "cloudId",
                        "variableName": "cloudId"
                    }
                ],
                "concreteType": "AquaOutgoingEmailLogsQueryApi",
                "kind": "LinkedField",
                "name": "aquaOutgoingEmailLogs",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "notificationActionType",
                                "variableName": "notificationActionType"
                            },
                            {
                                "kind": "Variable",
                                "name": "notificationType",
                                "variableName": "notificationType"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectId",
                                "variableName": "projectId"
                            }
                        ],
                        "kind": "LinkedField",
                        "name": "GetNotificationLogs",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "alias": "logs",
                                        "concreteType": "AquaOutgoingEmailLogConnection",
                                        "kind": "LinkedField",
                                        "name": "__aquaOutgoingEmail__logs_connection",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "AquaOutgoingEmailLogItemEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "logsTableOfTabs_logEdges"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "cursor"
                                                    },
                                                    {
                                                        "concreteType": "AquaOutgoingEmailLogItem",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v1 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "PageInfo",
                                                "kind": "LinkedField",
                                                "name": "pageInfo",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "startCursor"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "endCursor"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "hasNextPage"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "hasPreviousPage"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "type": "AquaOutgoingEmailLog"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "identifier"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "message"
                                    }
                                ],
                                "type": "QueryError"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$fa75551a827aac92$var$node.hash = "ce3f76d0fe1ca275bccfadfeb21cb8d7";
var $fa75551a827aac92$export$2e2bcd8739ae039 = $fa75551a827aac92$var$node;

});
parcelRegister("FXmIr", function(module, exports) {

$parcel$export(module.exports, "default", () => $f54bbd6ecd65ea56$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3d49926a21e5a63dd57e2f40a022ffb1>>
 * @relayHash 511bcf623b3a50b37e66bbcafe85dab2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f4018b0f727f75f6638f3ac77953d339c89aedc21681eda39f6c598e843dc195
const $f54bbd6ecd65ea56$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": 20,
            "kind": "LocalArgument",
            "name": "count"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cursor"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isUnsuppressionEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "notificationActionType"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "notificationType"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "cursor"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "aquaEmailLogsQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "count",
                            "variableName": "count"
                        },
                        {
                            "kind": "Variable",
                            "name": "cursor",
                            "variableName": "cursor"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "notificationTable_spaAppsServicedeskNotificationLogs_NotificationLogsTable"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "aquaEmailLogsQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "AquaOutgoingEmailLogsQueryApi",
                    "kind": "LinkedField",
                    "name": "aquaOutgoingEmailLogs",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "notificationActionType",
                                    "variableName": "notificationActionType"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "notificationType",
                                    "variableName": "notificationType"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "projectId",
                                    "variableName": "projectId"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "GetNotificationLogs",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v2 /*: any*/ ,
                                            "concreteType": "AquaOutgoingEmailLogConnection",
                                            "kind": "LinkedField",
                                            "name": "logs",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "AquaOutgoingEmailLogItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AquaOutgoingEmailLogItem",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "AquaIssueContext",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueContext",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssue",
                                                                            "kind": "LinkedField",
                                                                            "name": "issue",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "key"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "webUrl"
                                                                                },
                                                                                v3 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "notificationActionType"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "actionTimestamp"
                                                                },
                                                                {
                                                                    "concreteType": "AquaNotificationDetails",
                                                                    "kind": "LinkedField",
                                                                    "name": "notificationDetails",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "errorKey"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "mailboxMessage"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "recipient",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v1 /*: any*/ ,
                                                                        {
                                                                            "condition": "isUnsuppressionEnabled",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "accountId"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "email"
                                                                                }
                                                                            ],
                                                                            "type": "AtlassianAccountUser"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "name"
                                                                                }
                                                                            ],
                                                                            "type": "CustomerUser"
                                                                        },
                                                                        v3 /*: any*/ 
                                                                    ]
                                                                },
                                                                v1 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "startCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasPreviousPage"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "args": v2 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "aquaOutgoingEmail__logs",
                                            "kind": "LinkedHandle",
                                            "name": "logs"
                                        }
                                    ],
                                    "type": "AquaOutgoingEmailLog"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "identifier"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f4018b0f727f75f6638f3ac77953d339c89aedc21681eda39f6c598e843dc195",
            "metadata": {},
            "name": "aquaEmailLogsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f54bbd6ecd65ea56$var$node.hash = "ce3f76d0fe1ca275bccfadfeb21cb8d7";
var $f54bbd6ecd65ea56$export$2e2bcd8739ae039 = $f54bbd6ecd65ea56$var$node;

});


parcelRegister("9suPc", function(module, exports) {
$parcel$export(module.exports, "elementScroll", () => (parcelRequire("lASGB")).elementScroll);
$parcel$export(module.exports, "notUndefined", () => (parcelRequire("cDbvq")).notUndefined);
$parcel$export(module.exports, "observeElementOffset", () => (parcelRequire("lASGB")).observeElementOffset);
$parcel$export(module.exports, "observeElementRect", () => (parcelRequire("lASGB")).observeElementRect);
$parcel$export(module.exports, "observeWindowOffset", () => (parcelRequire("lASGB")).observeWindowOffset);
$parcel$export(module.exports, "observeWindowRect", () => (parcelRequire("lASGB")).observeWindowRect);
$parcel$export(module.exports, "Virtualizer", () => (parcelRequire("lASGB")).Virtualizer);
$parcel$export(module.exports, "windowScroll", () => (parcelRequire("lASGB")).windowScroll);

$parcel$export(module.exports, "useVirtualizer", () => $6e2ea3c4609c52d6$export$dd6d526d88b5a137);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $lASGB = parcelRequire("lASGB");
const $6e2ea3c4609c52d6$var$useIsomorphicLayoutEffect = typeof document !== "undefined" ? $5uXOq.useLayoutEffect : $5uXOq.useEffect;
function $6e2ea3c4609c52d6$var$useVirtualizerBase(options) {
    const rerender = $5uXOq.useReducer(()=>({}), {})[1];
    const resolvedOptions = {
        ...options,
        onChange: (instance2, sync)=>{
            var _a;
            if (sync) (0, $7nsd3.flushSync)(rerender);
            else rerender();
            (_a = options.onChange) == null || _a.call(options, instance2, sync);
        }
    };
    const [instance] = $5uXOq.useState(()=>new (0, $lASGB.Virtualizer)(resolvedOptions));
    instance.setOptions(resolvedOptions);
    $5uXOq.useEffect(()=>{
        return instance._didMount();
    }, []);
    $6e2ea3c4609c52d6$var$useIsomorphicLayoutEffect(()=>{
        return instance._willUpdate();
    });
    return instance;
}
function $6e2ea3c4609c52d6$export$dd6d526d88b5a137(options) {
    return $6e2ea3c4609c52d6$var$useVirtualizerBase({
        observeElementRect: $lASGB.observeElementRect,
        observeElementOffset: $lASGB.observeElementOffset,
        scrollToFn: (0, $lASGB.elementScroll),
        ...options
    });
}
function $6e2ea3c4609c52d6$export$645722dcac657cb9(options) {
    return $6e2ea3c4609c52d6$var$useVirtualizerBase({
        getScrollElement: ()=>typeof document !== "undefined" ? window : null,
        observeElementRect: (0, $lASGB.observeWindowRect),
        observeElementOffset: (0, $lASGB.observeWindowOffset),
        scrollToFn: (0, $lASGB.windowScroll),
        initialOffset: ()=>typeof document !== "undefined" ? window.scrollY : 0,
        ...options
    });
}

});
parcelRegister("lASGB", function(module, exports) {

$parcel$export(module.exports, "observeElementRect", () => $fb876145852c2505$export$5a50ff2cde8c3802);
$parcel$export(module.exports, "observeWindowRect", () => $fb876145852c2505$export$e911b82c7a99311);
$parcel$export(module.exports, "observeElementOffset", () => $fb876145852c2505$export$fbc040aee017375a);
$parcel$export(module.exports, "observeWindowOffset", () => $fb876145852c2505$export$518998f8c5d09287);
$parcel$export(module.exports, "windowScroll", () => $fb876145852c2505$export$2162c5b3eeedd27);
$parcel$export(module.exports, "elementScroll", () => $fb876145852c2505$export$1cdb988e5ab69fe7);
$parcel$export(module.exports, "Virtualizer", () => $fb876145852c2505$export$89be5a243e59c4b2);
$parcel$export(module.exports, "notUndefined", () => (parcelRequire("cDbvq")).notUndefined);

var $cDbvq = parcelRequire("cDbvq");
const $fb876145852c2505$export$76974b428a49f15b = (index)=>index;
const $fb876145852c2505$export$7eb7cb13fd21e5e1 = (range)=>{
    const start = Math.max(range.startIndex - range.overscan, 0);
    const end = Math.min(range.endIndex + range.overscan, range.count - 1);
    const arr = [];
    for(let i = start; i <= end; i++)arr.push(i);
    return arr;
};
const $fb876145852c2505$export$5a50ff2cde8c3802 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    const handler = (rect)=>{
        const { width: width, height: height } = rect;
        cb({
            width: Math.round(width),
            height: Math.round(height)
        });
    };
    handler(element.getBoundingClientRect());
    if (!targetWindow.ResizeObserver) return ()=>{};
    const observer = new targetWindow.ResizeObserver((entries)=>{
        const entry = entries[0];
        if (entry == null ? void 0 : entry.borderBoxSize) {
            const box = entry.borderBoxSize[0];
            if (box) {
                handler({
                    width: box.inlineSize,
                    height: box.blockSize
                });
                return;
            }
        }
        handler(element.getBoundingClientRect());
    });
    observer.observe(element, {
        box: "border-box"
    });
    return ()=>{
        observer.unobserve(element);
    };
};
const $fb876145852c2505$var$addEventListenerOptions = {
    passive: true
};
const $fb876145852c2505$export$e911b82c7a99311 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const handler = ()=>{
        cb({
            width: element.innerWidth,
            height: element.innerHeight
        });
    };
    handler();
    element.addEventListener("resize", handler, $fb876145852c2505$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("resize", handler);
    };
};
const $fb876145852c2505$var$supportsScrollend = typeof window == "undefined" ? true : "onscrollend" in window;
const $fb876145852c2505$export$fbc040aee017375a = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    let offset = 0;
    const fallback = $fb876145852c2505$var$supportsScrollend ? ()=>void 0 : (0, $cDbvq.debounce)(targetWindow, ()=>{
        cb(offset, false);
    }, instance.options.isScrollingResetDelay);
    const createHandler = (isScrolling)=>()=>{
            const { horizontal: horizontal, isRtl: isRtl } = instance.options;
            offset = horizontal ? element["scrollLeft"] * (isRtl && -1 || 1) : element["scrollTop"];
            fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    endHandler();
    element.addEventListener("scroll", handler, $fb876145852c2505$var$addEventListenerOptions);
    element.addEventListener("scrollend", endHandler, $fb876145852c2505$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        element.removeEventListener("scrollend", endHandler);
    };
};
const $fb876145852c2505$export$518998f8c5d09287 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    let offset = 0;
    const fallback = $fb876145852c2505$var$supportsScrollend ? ()=>void 0 : (0, $cDbvq.debounce)(targetWindow, ()=>{
        cb(offset, false);
    }, instance.options.isScrollingResetDelay);
    const createHandler = (isScrolling)=>()=>{
            offset = element[instance.options.horizontal ? "scrollX" : "scrollY"];
            fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    endHandler();
    element.addEventListener("scroll", handler, $fb876145852c2505$var$addEventListenerOptions);
    element.addEventListener("scrollend", endHandler, $fb876145852c2505$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        element.removeEventListener("scrollend", endHandler);
    };
};
const $fb876145852c2505$export$6aa9c23c0f5932af = (element, entry, instance)=>{
    if (entry == null ? void 0 : entry.borderBoxSize) {
        const box = entry.borderBoxSize[0];
        if (box) {
            const size = Math.round(box[instance.options.horizontal ? "inlineSize" : "blockSize"]);
            return size;
        }
    }
    return Math.round(element.getBoundingClientRect()[instance.options.horizontal ? "width" : "height"]);
};
const $fb876145852c2505$export$2162c5b3eeedd27 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
const $fb876145852c2505$export$1cdb988e5ab69fe7 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
class $fb876145852c2505$export$89be5a243e59c4b2 {
    constructor(opts){
        this.unsubs = [];
        this.scrollElement = null;
        this.targetWindow = null;
        this.isScrolling = false;
        this.scrollToIndexTimeoutId = null;
        this.measurementsCache = [];
        this.itemSizeCache = /* @__PURE__ */ new Map();
        this.pendingMeasuredCacheIndexes = [];
        this.scrollRect = null;
        this.scrollOffset = null;
        this.scrollDirection = null;
        this.scrollAdjustments = 0;
        this.elementsCache = /* @__PURE__ */ new Map();
        this.observer = /* @__PURE__ */ (()=>{
            let _ro = null;
            const get = ()=>{
                if (_ro) return _ro;
                if (!this.targetWindow || !this.targetWindow.ResizeObserver) return null;
                return _ro = new this.targetWindow.ResizeObserver((entries)=>{
                    entries.forEach((entry)=>{
                        this._measureElement(entry.target, entry);
                    });
                });
            };
            return {
                disconnect: ()=>{
                    var _a;
                    (_a = get()) == null || _a.disconnect();
                    _ro = null;
                },
                observe: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.observe(target, {
                        box: "border-box"
                    });
                },
                unobserve: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.unobserve(target);
                }
            };
        })();
        this.range = null;
        this.setOptions = (opts2)=>{
            Object.entries(opts2).forEach(([key, value])=>{
                if (typeof value === "undefined") delete opts2[key];
            });
            this.options = {
                debug: false,
                initialOffset: 0,
                overscan: 1,
                paddingStart: 0,
                paddingEnd: 0,
                scrollPaddingStart: 0,
                scrollPaddingEnd: 0,
                horizontal: false,
                getItemKey: $fb876145852c2505$export$76974b428a49f15b,
                rangeExtractor: $fb876145852c2505$export$7eb7cb13fd21e5e1,
                onChange: ()=>{},
                measureElement: $fb876145852c2505$export$6aa9c23c0f5932af,
                initialRect: {
                    width: 0,
                    height: 0
                },
                scrollMargin: 0,
                gap: 0,
                indexAttribute: "data-index",
                initialMeasurementsCache: [],
                lanes: 1,
                isScrollingResetDelay: 150,
                enabled: true,
                isRtl: false,
                ...opts2
            };
        };
        this.notify = (sync)=>{
            var _a, _b;
            (_b = (_a = this.options).onChange) == null || _b.call(_a, this, sync);
        };
        this.maybeNotify = (0, $cDbvq.memo)(()=>{
            this.calculateRange();
            return [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ];
        }, (isScrolling)=>{
            this.notify(isScrolling);
        }, {
            key: false,
            debug: ()=>this.options.debug,
            initialDeps: [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ]
        });
        this.cleanup = ()=>{
            this.unsubs.filter(Boolean).forEach((d)=>d());
            this.unsubs = [];
            this.observer.disconnect();
            this.scrollElement = null;
            this.targetWindow = null;
        };
        this._didMount = ()=>{
            return ()=>{
                this.cleanup();
            };
        };
        this._willUpdate = ()=>{
            var _a;
            const scrollElement = this.options.enabled ? this.options.getScrollElement() : null;
            if (this.scrollElement !== scrollElement) {
                this.cleanup();
                if (!scrollElement) {
                    this.maybeNotify();
                    return;
                }
                this.scrollElement = scrollElement;
                if (this.scrollElement && "ownerDocument" in this.scrollElement) this.targetWindow = this.scrollElement.ownerDocument.defaultView;
                else this.targetWindow = ((_a = this.scrollElement) == null ? void 0 : _a.window) ?? null;
                this.elementsCache.forEach((cached)=>{
                    this.observer.observe(cached);
                });
                this._scrollToOffset(this.getScrollOffset(), {
                    adjustments: void 0,
                    behavior: void 0
                });
                this.unsubs.push(this.options.observeElementRect(this, (rect)=>{
                    this.scrollRect = rect;
                    this.maybeNotify();
                }));
                this.unsubs.push(this.options.observeElementOffset(this, (offset, isScrolling)=>{
                    this.scrollAdjustments = 0;
                    this.scrollDirection = isScrolling ? this.getScrollOffset() < offset ? "forward" : "backward" : null;
                    this.scrollOffset = offset;
                    this.isScrolling = isScrolling;
                    this.maybeNotify();
                }));
            }
        };
        this.getSize = ()=>{
            if (!this.options.enabled) {
                this.scrollRect = null;
                return 0;
            }
            this.scrollRect = this.scrollRect ?? this.options.initialRect;
            return this.scrollRect[this.options.horizontal ? "width" : "height"];
        };
        this.getScrollOffset = ()=>{
            if (!this.options.enabled) {
                this.scrollOffset = null;
                return 0;
            }
            this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset === "function" ? this.options.initialOffset() : this.options.initialOffset);
            return this.scrollOffset;
        };
        this.getFurthestMeasurement = (measurements, index)=>{
            const furthestMeasurementsFound = /* @__PURE__ */ new Map();
            const furthestMeasurements = /* @__PURE__ */ new Map();
            for(let m = index - 1; m >= 0; m--){
                const measurement = measurements[m];
                if (furthestMeasurementsFound.has(measurement.lane)) continue;
                const previousFurthestMeasurement = furthestMeasurements.get(measurement.lane);
                if (previousFurthestMeasurement == null || measurement.end > previousFurthestMeasurement.end) furthestMeasurements.set(measurement.lane, measurement);
                else if (measurement.end < previousFurthestMeasurement.end) furthestMeasurementsFound.set(measurement.lane, true);
                if (furthestMeasurementsFound.size === this.options.lanes) break;
            }
            return furthestMeasurements.size === this.options.lanes ? Array.from(furthestMeasurements.values()).sort((a, b)=>{
                if (a.end === b.end) return a.index - b.index;
                return a.end - b.end;
            })[0] : void 0;
        };
        this.getMeasurementOptions = (0, $cDbvq.memo)(()=>[
                this.options.count,
                this.options.paddingStart,
                this.options.scrollMargin,
                this.options.getItemKey,
                this.options.enabled
            ], (count, paddingStart, scrollMargin, getItemKey, enabled)=>{
            this.pendingMeasuredCacheIndexes = [];
            return {
                count: count,
                paddingStart: paddingStart,
                scrollMargin: scrollMargin,
                getItemKey: getItemKey,
                enabled: enabled
            };
        }, {
            key: false
        });
        this.getMeasurements = (0, $cDbvq.memo)(()=>[
                this.getMeasurementOptions(),
                this.itemSizeCache
            ], ({ count: count, paddingStart: paddingStart, scrollMargin: scrollMargin, getItemKey: getItemKey, enabled: enabled }, itemSizeCache)=>{
            if (!enabled) {
                this.measurementsCache = [];
                this.itemSizeCache.clear();
                return [];
            }
            if (this.measurementsCache.length === 0) {
                this.measurementsCache = this.options.initialMeasurementsCache;
                this.measurementsCache.forEach((item)=>{
                    this.itemSizeCache.set(item.key, item.size);
                });
            }
            const min = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
            this.pendingMeasuredCacheIndexes = [];
            const measurements = this.measurementsCache.slice(0, min);
            for(let i = min; i < count; i++){
                const key = getItemKey(i);
                const furthestMeasurement = this.options.lanes === 1 ? measurements[i - 1] : this.getFurthestMeasurement(measurements, i);
                const start = furthestMeasurement ? furthestMeasurement.end + this.options.gap : paddingStart + scrollMargin;
                const measuredSize = itemSizeCache.get(key);
                const size = typeof measuredSize === "number" ? measuredSize : this.options.estimateSize(i);
                const end = start + size;
                const lane = furthestMeasurement ? furthestMeasurement.lane : i % this.options.lanes;
                measurements[i] = {
                    index: i,
                    start: start,
                    size: size,
                    end: end,
                    key: key,
                    lane: lane
                };
            }
            this.measurementsCache = measurements;
            return measurements;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.calculateRange = (0, $cDbvq.memo)(()=>[
                this.getMeasurements(),
                this.getSize(),
                this.getScrollOffset()
            ], (measurements, outerSize, scrollOffset)=>{
            return this.range = measurements.length > 0 && outerSize > 0 ? $fb876145852c2505$var$calculateRange({
                measurements: measurements,
                outerSize: outerSize,
                scrollOffset: scrollOffset
            }) : null;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getIndexes = (0, $cDbvq.memo)(()=>[
                this.options.rangeExtractor,
                this.calculateRange(),
                this.options.overscan,
                this.options.count
            ], (rangeExtractor, range, overscan, count)=>{
            return range === null ? [] : rangeExtractor({
                startIndex: range.startIndex,
                endIndex: range.endIndex,
                overscan: overscan,
                count: count
            });
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.indexFromElement = (node)=>{
            const attributeName = this.options.indexAttribute;
            const indexStr = node.getAttribute(attributeName);
            if (!indexStr) {
                console.warn(`Missing attribute name '${attributeName}={index}' on measured element.`);
                return -1;
            }
            return parseInt(indexStr, 10);
        };
        this._measureElement = (node, entry)=>{
            const index = this.indexFromElement(node);
            const item = this.measurementsCache[index];
            if (!item) return;
            const key = item.key;
            const prevNode = this.elementsCache.get(key);
            if (prevNode !== node) {
                if (prevNode) this.observer.unobserve(prevNode);
                this.observer.observe(node);
                this.elementsCache.set(key, node);
            }
            if (node.isConnected) this.resizeItem(index, this.options.measureElement(node, entry, this));
        };
        this.resizeItem = (index, size)=>{
            const item = this.measurementsCache[index];
            if (!item) return;
            const itemSize = this.itemSizeCache.get(item.key) ?? item.size;
            const delta = size - itemSize;
            if (delta !== 0) {
                if (this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(item, delta, this) : item.start < this.getScrollOffset() + this.scrollAdjustments) this._scrollToOffset(this.getScrollOffset(), {
                    adjustments: this.scrollAdjustments += delta,
                    behavior: void 0
                });
                this.pendingMeasuredCacheIndexes.push(item.index);
                this.itemSizeCache = new Map(this.itemSizeCache.set(item.key, size));
                this.notify(false);
            }
        };
        this.measureElement = (node)=>{
            if (!node) {
                this.elementsCache.forEach((cached, key)=>{
                    if (!cached.isConnected) {
                        this.observer.unobserve(cached);
                        this.elementsCache.delete(key);
                    }
                });
                return;
            }
            this._measureElement(node, void 0);
        };
        this.getVirtualItems = (0, $cDbvq.memo)(()=>[
                this.getIndexes(),
                this.getMeasurements()
            ], (indexes, measurements)=>{
            const virtualItems = [];
            for(let k = 0, len = indexes.length; k < len; k++){
                const i = indexes[k];
                const measurement = measurements[i];
                virtualItems.push(measurement);
            }
            return virtualItems;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getVirtualItemForOffset = (offset)=>{
            const measurements = this.getMeasurements();
            if (measurements.length === 0) return void 0;
            return (0, $cDbvq.notUndefined)(measurements[$fb876145852c2505$var$findNearestBinarySearch(0, measurements.length - 1, (index)=>(0, $cDbvq.notUndefined)(measurements[index]).start, offset)]);
        };
        this.getOffsetForAlignment = (toOffset, align)=>{
            const size = this.getSize();
            const scrollOffset = this.getScrollOffset();
            if (align === "auto") {
                if (toOffset <= scrollOffset) align = "start";
                else if (toOffset >= scrollOffset + size) align = "end";
                else align = "start";
            }
            if (align === "start") toOffset;
            else if (align === "end") toOffset = toOffset - size;
            else if (align === "center") toOffset = toOffset - size / 2;
            const scrollSizeProp = this.options.horizontal ? "scrollWidth" : "scrollHeight";
            const scrollSize = this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[scrollSizeProp] : this.scrollElement[scrollSizeProp] : 0;
            const maxOffset = scrollSize - size;
            return Math.max(Math.min(maxOffset, toOffset), 0);
        };
        this.getOffsetForIndex = (index, align = "auto")=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            const item = this.measurementsCache[index];
            if (!item) return void 0;
            const size = this.getSize();
            const scrollOffset = this.getScrollOffset();
            if (align === "auto") {
                if (item.end >= scrollOffset + size - this.options.scrollPaddingEnd) align = "end";
                else if (item.start <= scrollOffset + this.options.scrollPaddingStart) align = "start";
                else return [
                    scrollOffset,
                    align
                ];
            }
            const toOffset = align === "end" ? item.end + this.options.scrollPaddingEnd : item.start - this.options.scrollPaddingStart;
            return [
                this.getOffsetForAlignment(toOffset, align),
                align
            ];
        };
        this.isDynamicMode = ()=>this.elementsCache.size > 0;
        this.cancelScrollToIndex = ()=>{
            if (this.scrollToIndexTimeoutId !== null && this.targetWindow) {
                this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId);
                this.scrollToIndexTimeoutId = null;
            }
        };
        this.scrollToOffset = (toOffset, { align: align = "start", behavior: behavior } = {})=>{
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.getOffsetForAlignment(toOffset, align), {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.scrollToIndex = (index, { align: initialAlign = "auto", behavior: behavior } = {})=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            const offsetAndAlign = this.getOffsetForIndex(index, initialAlign);
            if (!offsetAndAlign) return;
            const [offset, align] = offsetAndAlign;
            this._scrollToOffset(offset, {
                adjustments: void 0,
                behavior: behavior
            });
            if (behavior !== "smooth" && this.isDynamicMode() && this.targetWindow) this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(()=>{
                this.scrollToIndexTimeoutId = null;
                const elementInDOM = this.elementsCache.has(this.options.getItemKey(index));
                if (elementInDOM) {
                    const [latestOffset] = (0, $cDbvq.notUndefined)(this.getOffsetForIndex(index, align));
                    if (!(0, $cDbvq.approxEqual)(latestOffset, this.getScrollOffset())) this.scrollToIndex(index, {
                        align: align,
                        behavior: behavior
                    });
                } else this.scrollToIndex(index, {
                    align: align,
                    behavior: behavior
                });
            });
        };
        this.scrollBy = (delta, { behavior: behavior } = {})=>{
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.getScrollOffset() + delta, {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.getTotalSize = ()=>{
            var _a;
            const measurements = this.getMeasurements();
            let end;
            if (measurements.length === 0) end = this.options.paddingStart;
            else end = this.options.lanes === 1 ? ((_a = measurements[measurements.length - 1]) == null ? void 0 : _a.end) ?? 0 : Math.max(...measurements.slice(-this.options.lanes).map((m)=>m.end));
            return Math.max(end - this.options.scrollMargin + this.options.paddingEnd, 0);
        };
        this._scrollToOffset = (offset, { adjustments: adjustments, behavior: behavior })=>{
            this.options.scrollToFn(offset, {
                behavior: behavior,
                adjustments: adjustments
            }, this);
        };
        this.measure = ()=>{
            this.itemSizeCache = /* @__PURE__ */ new Map();
            this.notify(false);
        };
        this.setOptions(opts);
    }
}
const $fb876145852c2505$var$findNearestBinarySearch = (low, high, getCurrentValue, value)=>{
    while(low <= high){
        const middle = (low + high) / 2 | 0;
        const currentValue = getCurrentValue(middle);
        if (currentValue < value) low = middle + 1;
        else if (currentValue > value) high = middle - 1;
        else return middle;
    }
    if (low > 0) return low - 1;
    else return 0;
};
function $fb876145852c2505$var$calculateRange({ measurements: measurements, outerSize: outerSize, scrollOffset: scrollOffset }) {
    const count = measurements.length - 1;
    const getOffset = (index)=>measurements[index].start;
    const startIndex = $fb876145852c2505$var$findNearestBinarySearch(0, count, getOffset, scrollOffset);
    let endIndex = startIndex;
    while(endIndex < count && measurements[endIndex].end < scrollOffset + outerSize)endIndex++;
    return {
        startIndex: startIndex,
        endIndex: endIndex
    };
}

});
parcelRegister("cDbvq", function(module, exports) {

$parcel$export(module.exports, "memo", () => $93220d646a94e11c$export$7c73462e0d25e514);
$parcel$export(module.exports, "notUndefined", () => $93220d646a94e11c$export$9a1adf421b69c6a);
$parcel$export(module.exports, "approxEqual", () => $93220d646a94e11c$export$8a4f1dcc58a69dbd);
$parcel$export(module.exports, "debounce", () => $93220d646a94e11c$export$61fc7d43ac8f84b0);
function $93220d646a94e11c$export$7c73462e0d25e514(getDeps, fn, opts) {
    let deps = opts.initialDeps ?? [];
    let result;
    return ()=>{
        var _a, _b, _c, _d;
        let depTime;
        if (opts.key && ((_a = opts.debug) == null ? void 0 : _a.call(opts))) depTime = Date.now();
        const newDeps = getDeps();
        const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index)=>deps[index] !== dep);
        if (!depsChanged) return result;
        deps = newDeps;
        let resultTime;
        if (opts.key && ((_b = opts.debug) == null ? void 0 : _b.call(opts))) resultTime = Date.now();
        result = fn(...newDeps);
        if (opts.key && ((_c = opts.debug) == null ? void 0 : _c.call(opts))) {
            const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
            const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
            const resultFpsPercentage = resultEndTime / 16;
            const pad = (str, num)=>{
                str = String(str);
                while(str.length < num)str = " " + str;
                return str;
            };
            console.info(`%c\u{23F1} ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
        }
        (_d = opts == null ? void 0 : opts.onChange) == null || _d.call(opts, result);
        return result;
    };
}
function $93220d646a94e11c$export$9a1adf421b69c6a(value, msg) {
    if (value === void 0) throw new Error(`Unexpected undefined${msg ? `: ${msg}` : ""}`);
    else return value;
}
const $93220d646a94e11c$export$8a4f1dcc58a69dbd = (a, b)=>Math.abs(a - b) < 1;
const $93220d646a94e11c$export$61fc7d43ac8f84b0 = (targetWindow, fn, ms)=>{
    let timeoutId;
    return function(...args) {
        targetWindow.clearTimeout(timeoutId);
        timeoutId = targetWindow.setTimeout(()=>fn.apply(this, args), ms);
    };
};

});



parcelRegister("ib5lJ", function(module, exports) {

$parcel$export(module.exports, "LogsTable", () => $ce633959119528e2$export$58be81f5c6860851);

var $igkYG = parcelRequire("igkYG");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $5KCCi = parcelRequire("5KCCi");
var $1Jlkv = parcelRequire("1Jlkv");

var $pa9q9 = parcelRequire("pa9q9");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $cYlk7 = parcelRequire("cYlk7");

var $5oFIy = parcelRequire("5oFIy");

var $1W29t = parcelRequire("1W29t");

var $cauZ3 = parcelRequire("cauZ3");

var $5w5Gb = parcelRequire("5w5Gb");

var $kMMUQ = parcelRequire("kMMUQ");

var $luOGq = parcelRequire("luOGq");
const $ce633959119528e2$var$issueFailuresTab = 'ISSUE_NOTIFICATION';
const $ce633959119528e2$var$handleUnblockEmailClick = async (triggerFlag, accountId)=>{
    try {
        await (0, $1W29t.unblockSuppressedEmail)(accountId);
        triggerFlag('success');
    } catch (e) {
        triggerFlag('error');
    }
};
const $ce633959119528e2$var$rowRenderer = (virtualRow, edgeData, formatMessage, projectKey, selectedTab, timeZone, triggerFlag)=>{
    const virtualRowIndex = virtualRow.index;
    if (!edgeData[virtualRowIndex]) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableRow, {
        "data-index": virtualRowIndex,
        height: virtualRow.size,
        translateY: virtualRow.start,
        key: virtualRowIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableCellSmall, {
        selectedTab: selectedTab
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableCellSmall, {
        selectedTab: selectedTab
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableCellMedium, {
        selectedTab: selectedTab
    }, formatMessage((0, $cauZ3.messages).loadMoreLogs)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableCellLarge, {
        selectedTab: selectedTab
    }));
    const { node: node } = edgeData[virtualRowIndex];
    const getDetailsCell = (details, tabSelected)=>{
        let errorMessageComponent;
        const accountId = node?.recipient?.accountId || '';
        if (details) errorMessageComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luOGq.ErrorMessage), {
            errorKey: details.errorKey,
            projectKey: projectKey,
            mailboxMessage: details.mailboxMessage,
            formatMessage: formatMessage,
            tabSelected: tabSelected,
            // actionTaken="NOT_REQUESTED"
            // actionTakenTimestamp="2025-04-28T04:52:21.710Z"
            timeZone: timeZone,
            handleUnblockEmailClick: ()=>$ce633959119528e2$var$handleUnblockEmailClick(triggerFlag, accountId)
        });
        const TooltipComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$InlineDialog, {
                ...props,
                ref: ref
            }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$LogsDetails, {
            selectedTab: selectedTab
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
            position: "bottom-start",
            component: TooltipComponent,
            content: selectedTab === $ce633959119528e2$var$issueFailuresTab && details?.errorKey?.toLowerCase() === 'suppressed' && (0, $4R6GH.fg)('unsuppress_customer_emails') ? undefined : errorMessageComponent
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
                "data-testid": "spa-apps-servicedesk-notification-logs.ui.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.span",
                "aria-label": "tooltip",
                ...tooltipProps
            }, errorMessageComponent)));
    };
    const getNotificationTypeCell = (notificationType)=>{
        if (!notificationType) return null;
        const notificationName = (0, $luOGq.getNotificationName)(notificationType, formatMessage);
        const TooltipComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$InlineDialog, {
                ...props,
                ref: ref
            }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$NotificationTypeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
            position: "bottom-start",
            component: TooltipComponent,
            content: notificationName
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", tooltipProps, notificationName)));
    };
    const getCustomerNameCell = (customerName)=>{
        const TooltipComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$InlineDialog, {
                ...props,
                ref: ref
            }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$CustomerNameWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
            position: "bottom-start",
            component: TooltipComponent,
            content: customerName
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", tooltipProps, customerName)));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), (0, $4R6GH.fg)('concurrent-rendering-fix-unique-list-key') ? {
        key: virtualRowIndex
    } : {}, edgeData.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableRow, {
        "data-index": virtualRowIndex,
        height: virtualRow.size,
        translateY: virtualRow.start,
        key: virtualRowIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableCellSmall, {
        selectedTab: selectedTab
    }, (0, $luOGq.getLogDateTime)(node?.actionTimestamp, timeZone)), selectedTab === $ce633959119528e2$var$issueFailuresTab && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableCellSmall, {
        selectedTab: selectedTab
    }, getNotificationTypeCell(node?.notificationActionType)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableCellMedium, {
        selectedTab: selectedTab
    }, getCustomerNameCell(node?.recipient?.email || node?.recipient?.name)), selectedTab === $ce633959119528e2$var$issueFailuresTab && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableCellSmaller, {
        selectedTab: selectedTab
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        target: "_blank",
        href: node?.issueContext?.issue?.webUrl || ''
    }, node?.issueContext?.issue?.key)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableCellLarge, {
        selectedTab: selectedTab
    }, getDetailsCell(node?.notificationDetails, selectedTab))));
};
const $ce633959119528e2$export$ca3b93602b516d4a = ({ selectedTab: selectedTab, children: children })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("table", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableHeaderCellSmall, {
        selectedTab: selectedTab
    }, formatMessage((0, $cauZ3.messages).tableHeaderDateTime)), selectedTab === $ce633959119528e2$var$issueFailuresTab && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableHeaderCellSmall, {
        selectedTab: selectedTab
    }, formatMessage((0, $cauZ3.messages).tableHeaderNotificationName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableHeaderCellMedium, {
        selectedTab: selectedTab
    }, formatMessage((0, $cauZ3.messages).tableHeaderCustomerEmail)), selectedTab === $ce633959119528e2$var$issueFailuresTab && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableHeaderCellSmaller, {
        selectedTab: selectedTab
    }, formatMessage((0, $4R6GH.fg)('itsm-issue-renaming') ? (0, $cauZ3.messages).ticketKeyIssueTermRefresh : (0, $cauZ3.messages).ticketKey)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableHeaderCellLarge, {
        selectedTab: selectedTab
    }, formatMessage((0, $cauZ3.messages).tableHeaderErrorMessage)))), children);
};
const $ce633959119528e2$export$84fdb000f10c6779 = ({ data: data, virtualizer: virtualizer, projectKey: projectKey, outgoingMailConfigData: outgoingMailConfigData, selectedTab: selectedTab })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const triggerFlag = (appearance)=>{
        const isError = appearance === 'error';
        showFlag({
            type: appearance,
            title: !isError ? formatMessage((0, $cauZ3.messages).emailSuccessFlagHeading) : formatMessage((0, $cauZ3.messages).emailErrorFlagHeading),
            description: !isError ? formatMessage((0, $cauZ3.messages).emailSuccessFlagDescription) : formatMessage((0, $cauZ3.messages).emailErrorFlagDescription),
            isAutoDismiss: true,
            messageId: 'spa-apps-servicedesk-notification-logs.ui.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.show-flag.success',
            messageType: 'transactional'
        });
    };
    const { data: { user: user } } = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $cYlk7.useCurrentUser)();
    const timeZone = typeof user.timeZone === 'string' ? user.timeZone : '';
    const { outgoingMailConfig: outgoingMailConfig, error: error, loading: loading } = outgoingMailConfigData; // when we don't have customer logs i.e 0 logs
    if (!data.length && !error && !loading && outgoingMailConfig !== null) {
        if (!outgoingMailConfig?.enabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireTrackAnalytics), {
            eventName: "LogsTableInTabsLayout RenderOutgoingMailConfigDisabledTextAndEmptyTable"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$export$ca3b93602b516d4a, {
            selectedTab: selectedTab
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5w5Gb.NoDataEnableOutgoingMailInfo), null)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireTrackAnalytics), {
            eventName: "LogsTableInTabsLayout RenderEmptyTable"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$export$ca3b93602b516d4a, {
            selectedTab: selectedTab
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kMMUQ.NoRecords), null)));
    }
    if (data.length) // when we have customer logs show table of records
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireTrackAnalytics), {
        eventName: "LogsTableInTabsLayout RenderTableWithData"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$InfiniteScrollTable, {
        totalSize: virtualizer.getTotalSize(),
        "data-testid": "spa-apps-servicedesk-notification-logs.ui.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.infinite-scroll-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$Thead, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableHeaderCellSmall, {
        selectedTab: selectedTab
    }, formatMessage((0, $cauZ3.messages).tableHeaderDateTime)), selectedTab === $ce633959119528e2$var$issueFailuresTab && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableHeaderCellSmall, {
        selectedTab: selectedTab
    }, formatMessage((0, $cauZ3.messages).tableHeaderNotificationName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableHeaderCellMedium, {
        selectedTab: selectedTab
    }, formatMessage((0, $cauZ3.messages).tableHeaderCustomerEmail)), selectedTab === $ce633959119528e2$var$issueFailuresTab && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableHeaderCellSmaller, {
        selectedTab: selectedTab
    }, formatMessage((0, $cauZ3.messages).ticketKey)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableHeaderCellLarge, {
        selectedTab: selectedTab
    }, formatMessage((0, $cauZ3.messages).tableHeaderErrorMessage)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableBody, {
        "data-testid": "spa-apps-servicedesk-notification-logs.ui.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.table-body"
    }, virtualizer.getVirtualItems().map((virtualRow)=>$ce633959119528e2$var$rowRenderer(virtualRow, data, formatMessage, projectKey, selectedTab, timeZone, triggerFlag)))));
    return null;
};
const $ce633959119528e2$export$58be81f5c6860851 = ({ allEdges: allEdges, virtualizer: virtualizer, projectKey: projectKey, outgoingMailConfigData: outgoingMailConfigData, selectedTab: selectedTab })=>{
    const LogsDataFragment = (0, $igkYG.default);
    const data = (0, $8Uumt.useFragment)(LogsDataFragment, allEdges);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$export$84fdb000f10c6779, {
        data: data,
        virtualizer: virtualizer,
        projectKey: projectKey,
        outgoingMailConfigData: outgoingMailConfigData,
        selectedTab: selectedTab
    });
};
const $ce633959119528e2$var$issueFailureTab = 'ISSUE_NOTIFICATION'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce633959119528e2$var$LogsDetails = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { selectedTab: selectedTab, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1ule _o5721q9c _1bto1l2s",
            __cmplp.selectedTab === $ce633959119528e2$var$issueFailureTab ? "_1bsb1ogm" : "_1bsbcv93",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce633959119528e2$var$CustomerNameWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1ule _o5721q9c _1bto1l2s _1bsb1ogy",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce633959119528e2$var$NotificationTypeWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1ule _o5721q9c _1bto1l2s _1bsb1ogy",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce633959119528e2$var$TableCellSmaller = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "td", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { selectedTab: selectedTab, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _1bah1y6m",
            __cmplp.selectedTab === $ce633959119528e2$var$issueFailureTab ? "_1bsb9by0" : "_1bsbka7h",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce633959119528e2$var$TableCellSmall = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "td", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { selectedTab: selectedTab, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _1bah1y6m",
            __cmplp.selectedTab === $ce633959119528e2$var$issueFailureTab ? "_1bsbrq8m" : "_1bsbka7h",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce633959119528e2$var$TableCellMedium = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "td", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { selectedTab: selectedTab, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _1bah1y6m",
            __cmplp.selectedTab === $ce633959119528e2$var$issueFailureTab ? "_1bsbka7h" : "_1bsb1x1l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce633959119528e2$var$TableCellLarge = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "td", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { selectedTab: selectedTab, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _1bah1y6m",
            __cmplp.selectedTab === $ce633959119528e2$var$issueFailureTab ? "_1bsbxe31" : "_1bsb1ssb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce633959119528e2$var$Thead = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "thead", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_154iidpf _kqsw1if8 _1pbyb4wl _bfhkvuon _syaz1gjq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce633959119528e2$var$TableHeaderCellSmaller = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { selectedTab: selectedTab, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _1bah1y6m _kqsw1if8 _k48pi7a9",
            __cmplp.selectedTab === $ce633959119528e2$var$issueFailureTab ? "_1bsb9by0" : "_1bsbka7h",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce633959119528e2$var$TableHeaderCellSmall = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { selectedTab: selectedTab, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _1bah1y6m _kqsw1if8 _k48pi7a9",
            __cmplp.selectedTab === $ce633959119528e2$var$issueFailureTab ? "_1bsbrq8m" : "_1bsbka7h",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce633959119528e2$var$TableHeaderCellMedium = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { selectedTab: selectedTab, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _1bah1y6m _kqsw1if8 _k48pi7a9",
            __cmplp.selectedTab === $ce633959119528e2$var$issueFailureTab ? "_1bsbka7h" : "_1bsb1x1l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce633959119528e2$var$TableHeaderCellLarge = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { selectedTab: selectedTab, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _1bah1y6m _kqsw1if8 _k48pi7a9",
            __cmplp.selectedTab === $ce633959119528e2$var$issueFailureTab ? "_1bsbxe31" : "_1bsb1ssb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce633959119528e2$var$TableRow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "tr", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { translateY: translateY, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $lD23V.default)(`${__cmplp.height}px`),
            "--_1eykf4m": (0, $lD23V.default)(`translateY(${__cmplp.translateY}px)`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1bsb1osq _4t3i2nrh _t9ec1inw _19pku2gc _otyru2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce633959119528e2$var$TableBody = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "tbody", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1kw7",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce633959119528e2$var$InfiniteScrollTable = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "table", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { totalSize: totalSize, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_r9fzc2": (0, $lD23V.default)(`${__cmplp.totalSize}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1651 _1bsb1osq _kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce633959119528e2$var$InlineDialog = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $1Jlkv.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _ca0q7vkz _u5f31tcg _n3td7vkz _19bv1tcg _bfhkvuon _16qs1cd0 _p12fnklw _vchh18uv _1nmz1hna",
            __cmplp.className
        ])
    });
});

});
parcelRegister("igkYG", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b27263127f0e5e4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fb4e239244a0b2696c41762eb2569041>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4b27263127f0e5e4$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isUnsuppressionEnabled"
        }
    ],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "logsTableOfTabs_logEdges",
    "selections": [
        {
            "concreteType": "AquaOutgoingEmailLogItem",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                {
                    "concreteType": "AquaIssueContext",
                    "kind": "LinkedField",
                    "name": "issueContext",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issue",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "webUrl"
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "notificationActionType"
                },
                {
                    "kind": "ScalarField",
                    "name": "actionTimestamp"
                },
                {
                    "concreteType": "AquaNotificationDetails",
                    "kind": "LinkedField",
                    "name": "notificationDetails",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "errorKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "mailboxMessage"
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "name": "recipient",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isUnsuppressionEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "accountId"
                                }
                            ]
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "email"
                                }
                            ],
                            "type": "AtlassianAccountUser"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ],
                            "type": "CustomerUser"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "AquaOutgoingEmailLogItemEdge"
};
$4b27263127f0e5e4$var$node.hash = "a47e026d06670197abd7c2d3bdb3859c";
var $4b27263127f0e5e4$export$2e2bcd8739ae039 = $4b27263127f0e5e4$var$node;

});

parcelRegister("1W29t", function(module, exports) {

$parcel$export(module.exports, "unblockSuppressedEmail", () => $e93822aacb65359d$export$2c7df8253405ba1c);
const $e93822aacb65359d$var$getUrl = (accountId)=>{
    return `/rest/servicedesk/notifications/1/email/unsuppress/${accountId}`;
};
const $e93822aacb65359d$export$2c7df8253405ba1c = async (accountId)=>{
    const response = await fetch($e93822aacb65359d$var$getUrl(accountId), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) {
        const body = await response.json();
        throw new Error(body.errors[0].errorMessage);
    }
};

});

parcelRegister("cauZ3", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3dc15c60c4cd538d$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $3dc15c60c4cd538d$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    renderingFailed: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.rendering-failed",
        "defaultMessage": "Internal error. {linkStart}Resend the invite{linkEnd} later."
    },
    requestTooLong: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.request-too-long",
        "defaultMessage": "Notification size is greater than 6 MB. Reduce the size of customer invite template."
    },
    emailValidationFailure: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.email-validation-failure",
        "defaultMessage": "Unable to validate recipient\u2019s email address. Check the format and invite again."
    },
    rfc1918LanIpRoutingFailure: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.rfc-1918-lan-ip-routing-failure",
        "defaultMessage": "Recipient\u2019s email address belongs to a private address space. Invite again using the correct email address."
    },
    suppressedMessage: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.suppressed-message",
        "defaultMessage": "Recipient\u2019s email address is on a suppression list. Resend invite from the {linkStart}Customers page{linkEnd}."
    },
    suppressedInviteMessage: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.suppressed-invite-message",
        "defaultMessage": "Invite blocked. Resend the invite from the {linkStart}Customers page{linkEnd}."
    },
    suppressedMessageForRequestNotifications: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.suppressed-message-for-request-notifications",
        "defaultMessage": "Recipient\u2019s email address is on a suppression list."
    },
    bounced: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.bounced",
        "defaultMessage": "Error from email provider"
    },
    emailNotificationLimitReached: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.email-notification-limit-reached",
        "defaultMessage": "Reached the email notifications limit for {siteUrl}."
    },
    defaultErrorMessage: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.default-error-message",
        "defaultMessage": "An unknown error occurred. Try again later."
    },
    defaultErrorMessageForRequestNotification: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.default-error-message-for-request-notification",
        "defaultMessage": "An unknown error occurred."
    },
    tableHeaderDateTime: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.table-header-date-time",
        "defaultMessage": "Date and time"
    },
    tableHeaderNotificationName: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.table-header-notification-name",
        "defaultMessage": "Notification name"
    },
    tableHeaderCustomerEmail: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.table-header-customer-email",
        "defaultMessage": "Recipient"
    },
    tableHeaderErrorMessage: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.table-header-error-message",
        "defaultMessage": "Details"
    },
    ticketKey: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.ticket-key",
        "defaultMessage": "Issue key"
    },
    ticketKeyIssueTermRefresh: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.ticket-key-issue-term-refresh",
        "defaultMessage": "Work item key"
    },
    customerInvited: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.customer-invited",
        "defaultMessage": "Customer invited"
    },
    requestCreated: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.request-created",
        "defaultMessage": "Request created"
    },
    publicCommentAdded: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.public-comment-added",
        "defaultMessage": "Public comment added"
    },
    publicCommentEdited: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.public-comment-edited",
        "defaultMessage": "Public comment edited"
    },
    requestResolved: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.request-resolved",
        "defaultMessage": "Request resolved"
    },
    requestReopened: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.request-reopened",
        "defaultMessage": "Request reopened"
    },
    participantAdded: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.participant-added",
        "defaultMessage": "Participant added"
    },
    organizationAdded: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.organization-added",
        "defaultMessage": "Organization added"
    },
    approvalRequired: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.approval-required",
        "defaultMessage": "Approval required"
    },
    customerVisibleStatusChanged: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.customer-visible-status-changed",
        "defaultMessage": "Customer-visible status changed"
    },
    customNotification: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.custom-notification",
        "defaultMessage": "Custom notification"
    },
    loadMoreLogs: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.load-more-logs",
        "defaultMessage": "Loading more logs..."
    },
    emailBlockedText: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.email-blocked-text",
        "defaultMessage": "Email blocked."
    },
    emailUnsuppressBtnLabel: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.email-unsuppress-btn-label",
        "defaultMessage": "Unblock email address"
    },
    emailUnblockSuccess: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.email-unblock-success",
        "defaultMessage": "Email was blocked. Unblocked at {actionTakenTime}."
    },
    emailSuccessFlagHeading: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.email-success-flag-heading",
        "defaultMessage": "Unblocking email address"
    },
    emailSuccessFlagDescription: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.email-success-flag-description",
        "defaultMessage": "It may take a few minutes to complete this action. Undelivered notifications will not be resent."
    },
    emailErrorFlagHeading: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.email-error-flag-heading",
        "defaultMessage": "We\u2019re unable to unblock email address"
    },
    emailErrorFlagDescription: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.email-error-flag-description",
        "defaultMessage": "Try again in a few minutes."
    }
});

});

parcelRegister("5w5Gb", function(module, exports) {

$parcel$export(module.exports, "NoDataEnableOutgoingMailInfo", () => $9860b096251afcf0$export$31d032be89b0df83);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $5E93O = parcelRequire("5E93O");

var $8Q4sF = parcelRequire("8Q4sF");

var $2JXc1 = parcelRequire("2JXc1");

var $koVbs = parcelRequire("koVbs");

var $kiDgp = parcelRequire("kiDgp");
const $9860b096251afcf0$var$Bold = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, children);
const $9860b096251afcf0$export$31d032be89b0df83 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const siteUrl = window.location.hostname;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9860b096251afcf0$var$OutgoingMailErrorContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9860b096251afcf0$var$OutgoingMailInfoWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2JXc1.default), {
        height: "222",
        width: "191",
        alt: "no failure logs"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9860b096251afcf0$var$OutgoingMailErrorText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5E93O))), {
        LEGACY_size: "medium",
        spacing: "spacious",
        label: "",
        color: "var(--ds-icon-danger, #C9372C)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Q4sF.FormattedI18nMessage), {
        message: formatMessage((0, $kiDgp.messages).configDisabledAndNoFailureLogs, {
            boldStart: '{boldStart}',
            boldEnd: '{boldEnd}',
            siteUrl: siteUrl
        }),
        componentsMapping: {
            bold: $9860b096251afcf0$var$Bold
        }
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9860b096251afcf0$var$OutgoingMailErrorContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3idgin",
            __cmplp.className
        ])
    });
});
const $9860b096251afcf0$var$OutgoingMailInfoWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkutpp _2hwxutpp _otyrutpp _18u0idpf _y3gn1h6o _1e0c1txw _1bah1h6o _4cvr1h6o _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $9860b096251afcf0$var$OutgoingMailErrorText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qutpp _u5f3utpp _n3tdutpp _19bvidpf _1e0c1o8l _vr2wh2mm _1t1812x7 _1tnd12x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2JXc1", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5d3fe7c3133ec07$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = mmwr66tqxzps49fhmn4694w
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/mmwr66tqxzps49fhmn4694w

var $dCLgq = parcelRequire("dCLgq");

var $cid60 = parcelRequire("cid60");

var $6y2Qu = parcelRequire("6y2Qu");
const $c5d3fe7c3133ec07$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($6y2Qu)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($cid60))
});
var $c5d3fe7c3133ec07$export$2e2bcd8739ae039 = $c5d3fe7c3133ec07$var$Illustration;
// for advanced use only
const $c5d3fe7c3133ec07$export$a179c88182cb9d56 = [
    0,
    0,
    191,
    222
];

});
parcelRegister("cid60", function(module, exports) {
module.exports = new URL("lock-closed-darkmode.26d51607.svg", import.meta.url).toString();

});

parcelRegister("6y2Qu", function(module, exports) {
module.exports = new URL("lock-closed.22dbfd6e.svg", import.meta.url).toString();

});


parcelRegister("kiDgp", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c535b9b4b8efd498$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $c535b9b4b8efd498$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    configDisabledAndNoFailureLogs: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.no-data-enable-outgoing-mail-info.config-disabled-and-no-failure-logs",
        "defaultMessage": "No data available as {boldStart}Outgoing Mail{boldEnd} is disabled for {siteUrl}."
    }
});

});


parcelRegister("kMMUQ", function(module, exports) {

$parcel$export(module.exports, "NoRecords", () => $e514ea095591694f$export$cdb065a719ea8884);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $3a3KV = parcelRequire("3a3KV");

var $koVbs = parcelRequire("koVbs");

var $6oCSI = parcelRequire("6oCSI");
const $e514ea095591694f$export$cdb065a719ea8884 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e514ea095591694f$var$AllGoodContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e514ea095591694f$var$AllGoodContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $e514ea095591694f$var$imageContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3a3KV.default), {
        height: "150",
        width: "139",
        alt: "no failure logs"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("h5", null, formatMessage((0, $6oCSI.messages).configEnabledAndNoFailureLogsMainText))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e514ea095591694f$var$AllGoodContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3ibfng",
            __cmplp.className
        ])
    });
});
const $e514ea095591694f$var$AllGoodContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1h6o _1j5t1ejb _nvys1ejb _avw21ejb _19sq1ejb _1gtfidpf",
            __cmplp.className
        ])
    });
});
const $e514ea095591694f$var$imageContainerStyles = (0, $2s57o.xcss)({
    display: 'flex',
    justifyContent: 'center'
});

});
parcelRegister("3a3KV", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f7e7138359f79b9$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = vb8b89gnsq3h8xbh8jsqkgkp
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/vb8b89gnsq3h8xbh8jsqkgkp

var $dCLgq = parcelRequire("dCLgq");

var $gtj36 = parcelRequire("gtj36");
const $2f7e7138359f79b9$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($gtj36)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($gtj36))
});
var $2f7e7138359f79b9$export$2e2bcd8739ae039 = $2f7e7138359f79b9$var$Illustration;
// for advanced use only
const $2f7e7138359f79b9$export$a179c88182cb9d56 = [
    0,
    0,
    226,
    244
];

});
parcelRegister("gtj36", function(module, exports) {
module.exports = new URL("service-success.e99f1cd7.svg", import.meta.url).toString();

});


parcelRegister("6oCSI", function(module, exports) {

$parcel$export(module.exports, "messages", () => $bf7e923ae07c269c$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $bf7e923ae07c269c$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    configEnabledAndNoFailureLogsMainText: {
        "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.no-records.config-enabled-and-no-failure-logs-main-text",
        "defaultMessage": "All set! Customer notifications were delivered successfully for your project."
    }
});

});


parcelRegister("luOGq", function(module, exports) {

$parcel$export(module.exports, "getLogDateTime", () => $0ced444745e60ec9$export$fbe52a537db76a48);
$parcel$export(module.exports, "ErrorMessage", () => $0ced444745e60ec9$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "getNotificationName", () => $0ced444745e60ec9$export$dc44215dd42a02db);

var $5uXOq = parcelRequire("5uXOq");

var $7CMcV = parcelRequire("7CMcV");

var $cNW3X = parcelRequire("cNW3X");

var $gVM6m = parcelRequire("gVM6m");
var $6eFvr = parcelRequire("6eFvr");
var $2s57o = parcelRequire("2s57o");

var $4R6GH = parcelRequire("4R6GH");

var $8Q4sF = parcelRequire("8Q4sF");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $cauZ3 = parcelRequire("cauZ3");
const $0ced444745e60ec9$var$issueFailuresTab = 'ISSUE_NOTIFICATION';
const $0ced444745e60ec9$export$fbe52a537db76a48 = (dateString, timeZone)=>{
    if (dateString) {
        const dateObj = (0, $7CMcV.default)(dateString, timeZone);
        const year = dateObj.getFullYear();
        const month = dateObj.toLocaleString('en-us', {
            month: 'short'
        });
        const day = dateObj.getDate();
        const hours = dateObj.getHours();
        const minutes = dateObj.getMinutes();
        // Format the output date string
        const outputDateString = `${month} ${day}, ${year} ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
        return outputDateString;
    }
    return dateString;
};
const $0ced444745e60ec9$var$FormattedErrorWithLinkButton = ({ href: href, errorMessage: errorMessage, onLinkButtonClicked: onLinkButtonClicked })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Q4sF.FormattedI18nMessage), {
        componentsMapping: {
            link: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
                    appearance: "link",
                    spacing: "none",
                    href: href,
                    target: "_blank",
                    onClick: onLinkButtonClicked
                }, props.children)
        },
        message: formatMessage(errorMessage, {
            linkStart: '{linkStart}',
            linkEnd: '{linkEnd}'
        })
    });
};
const $0ced444745e60ec9$var$FormattedErrorText = ({ errorMessage: errorMessage })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage(errorMessage));
};
const $0ced444745e60ec9$export$300e9e75480e4710 = ({ mailboxMessage: mailboxMessage, formatMessage: formatMessage })=>{
    const bouncedMessage = `${formatMessage((0, $cauZ3.messages).bounced)}: ${mailboxMessage}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, bouncedMessage);
};
const $0ced444745e60ec9$export$915e9e7bd4f0f96d = ({ errorKey: errorKey, projectKey: projectKey, mailboxMessage: mailboxMessage, formatMessage: formatMessage, tabSelected: tabSelected, actionTaken: actionTaken, actionTakenTimestamp: actionTakenTimestamp, timeZone: timeZone, handleUnblockEmailClick: handleUnblockEmailClick })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const onInternalErrorResendInviteClicked = (0, $5uXOq.useCallback)(()=>(0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'internalErrorResendInviteLink',
            action: 'clicked'
        }), 'internalErrorResendInvite'), [
        createAnalyticsEvent
    ]);
    const suppressedErrorGoToCustomersPageClicked = (0, $5uXOq.useCallback)(()=>(0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'suppressedErrorGoToCustomersPageLink',
            action: 'clicked'
        }), 'suppressedErrorGoToCustomersPage'), [
        createAnalyticsEvent
    ]);
    switch(errorKey && errorKey.toLowerCase()){
        case 'rendering_failed':
        case 'retrieve_configuration_failed':
        case 'retryable_am_failure':
        case 'unknown_failure':
            {
                const href = `/jira/servicedesk/projects/${projectKey}/customers`;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ced444745e60ec9$var$FormattedErrorWithLinkButton, {
                    href: href,
                    errorMessage: (0, $cauZ3.messages).renderingFailed,
                    onLinkButtonClicked: onInternalErrorResendInviteClicked
                });
            }
        case 'request_too_long':
        case 'request_size_exceeded':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ced444745e60ec9$var$FormattedErrorText, {
                errorMessage: (0, $cauZ3.messages).requestTooLong
            });
        case 'email_validation_failure':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ced444745e60ec9$var$FormattedErrorText, {
                errorMessage: (0, $cauZ3.messages).emailValidationFailure
            });
        case 'rfc1918_lan_ip_routing_failure':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ced444745e60ec9$var$FormattedErrorText, {
                errorMessage: (0, $cauZ3.messages).rfc1918LanIpRoutingFailure
            });
        case 'suppressed':
            {
                if (tabSelected === $0ced444745e60ec9$var$issueFailuresTab) {
                    if ((0, $4R6GH.fg)('unsuppress_customer_emails')) return actionTaken !== 'UNBLOCK_REQUESTED' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), null, `${formatMessage((0, $cauZ3.messages).emailBlockedText)} `), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gVM6m.default), {
                        onClick: handleUnblockEmailClick,
                        padding: "space.0",
                        backgroundColor: "color.background.neutral.subtle",
                        xcss: $0ced444745e60ec9$var$pressableStyles,
                        "aria-label": formatMessage((0, $cauZ3.messages).emailUnsuppressBtnLabel)
                    }, formatMessage((0, $cauZ3.messages).emailUnsuppressBtnLabel))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), null, formatMessage((0, $cauZ3.messages).emailUnblockSuccess, {
                        actionTakenTime: $0ced444745e60ec9$export$fbe52a537db76a48(actionTakenTimestamp, timeZone)
                    }));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ced444745e60ec9$var$FormattedErrorText, {
                        errorMessage: (0, $cauZ3.messages).suppressedMessageForRequestNotifications
                    });
                }
                const href = `/jira/servicedesk/projects/${projectKey}/customers`;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ced444745e60ec9$var$FormattedErrorWithLinkButton, {
                    href: href,
                    errorMessage: (0, $4R6GH.fg)('unsuppress_customer_emails') ? (0, $cauZ3.messages).suppressedInviteMessage : (0, $cauZ3.messages).suppressedMessage,
                    onLinkButtonClicked: suppressedErrorGoToCustomersPageClicked
                });
            }
        case 'email_notification_limit_reached':
            {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                const siteUrl = window.location.hostname;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
                    values: {
                        siteUrl: siteUrl
                    },
                    ...(0, $cauZ3.messages).emailNotificationLimitReached
                });
            }
        case 'bounced':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ced444745e60ec9$export$300e9e75480e4710, {
                mailboxMessage: mailboxMessage,
                formatMessage: formatMessage
            });
        default:
            if (tabSelected === $0ced444745e60ec9$var$issueFailuresTab) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ced444745e60ec9$var$FormattedErrorText, {
                errorMessage: (0, $cauZ3.messages).defaultErrorMessageForRequestNotification
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ced444745e60ec9$var$FormattedErrorText, {
                errorMessage: (0, $cauZ3.messages).defaultErrorMessage
            });
    }
};
const $0ced444745e60ec9$export$dc44215dd42a02db = (notificationType, formatMessage)=>{
    switch(notificationType.toLowerCase()){
        case 'customer_invite':
            return formatMessage((0, $cauZ3.messages).customerInvited);
        case 'request_created':
            return formatMessage((0, $cauZ3.messages).requestCreated);
        case 'public_comment_added':
            return formatMessage((0, $cauZ3.messages).publicCommentAdded);
        case 'public_comment_edited':
            return formatMessage((0, $cauZ3.messages).publicCommentEdited);
        case 'request_resolved':
            return formatMessage((0, $cauZ3.messages).requestResolved);
        case 'request_reopened':
            return formatMessage((0, $cauZ3.messages).requestReopened);
        case 'participant_added':
            return formatMessage((0, $cauZ3.messages).participantAdded);
        case 'organisation_added':
            return formatMessage((0, $cauZ3.messages).organizationAdded);
        case 'approval_required':
            return formatMessage((0, $cauZ3.messages).approvalRequired);
        case 'customer_visible_status_changed':
            return formatMessage((0, $cauZ3.messages).customerVisibleStatusChanged);
        case 'custom_notification':
            return formatMessage((0, $cauZ3.messages).customNotification);
        default:
            return '';
    }
};
const $0ced444745e60ec9$var$pressableStyles = (0, $2s57o.xcss)({
    color: 'color.link',
    fontWeight: "var(--ds-font-weight-medium, 500)",
    ':hover': {
        textDecoration: 'underline'
    },
    ':active': {
        color: 'color.link.pressed'
    }
});

});









//# sourceMappingURL=async-servicedesk-notification-logs.0db1aa05.js.map
